import React, { useEffect, useRef, useState } from 'react';
import Footer from './Footer';
import InvestorData from '../Communication/InvestorData';
import SecondSectionImage from '../../Assets/img/InvestorPageAssets/Rectangle 6376.png';
import ThirdSectionImage from '../../Assets/img/InvestorPageAssets/ThirdSection.png';
import ThirdSectionImageMobile from '../../Assets/img/InvestorPageAssets/Group 289478.png';
import NavBarInvestor from '../NavBar/NavBarInvestor';
import ImageSlider from '../SideScroller/ImageSlider';
import BGVideoTN from '../../Assets/img/InvestorPageAssets/Thumbnail.mp4';
import SolutionVideo from '../../Assets/img/InvestorPageAssets/Bundle Open 2.mp4';
import TeamImage from '../../Assets/img/InvestorPageAssets/All Team_1.mp4';
import SupplyChain from '../../Assets/img/InvestorPageAssets/SupplyChain.png';
import SupplyChainMobile from '../../Assets/img/InvestorPageAssets/Mobile.png';
import NextGen_MarketPlace from '../../Assets/img/InvestorPageAssets/Group 289429.svg';
import NextGen_MarketPlaceMobile from '../../Assets/img/InvestorPageAssets/Group 289481.png';
import FirstMoverAdvantage from '../../Assets/img/InvestorPageAssets/Phone.svg';
import ProvenDemand from '../../Assets/img/InvestorPageAssets/NewDesktopImage.svg';
import ProvenDemandMobile from '../../Assets/img/InvestorPageAssets/NewMobileImage.svg';
import EndingImage from '../../Assets/img/InvestorPageAssets/Thankyou.png';
import YouTubeEmbed from '../YoutubeEmbed/YouTubeEmbed';
import Amrit from '../../Assets/img/InvestorPageAssets/Team/Amrit.png';
import Joe from '../../Assets/img/InvestorPageAssets/Team/Joe.png';
import Jose from '../../Assets/img/InvestorPageAssets/Team/Jose.png';
import John from '../../Assets/img/InvestorPageAssets/Team/John.png';
import Danny from '../../Assets/img/InvestorPageAssets/Team/Danny.png';
import Karim from '../../Assets/img/InvestorPageAssets/Team/Karim.png';
import Kris from '../../Assets/img/InvestorPageAssets/Team/kris.png';
import Mury from '../../Assets/img/InvestorPageAssets/Team/Murry.png';
import Nee from '../../Assets/img/InvestorPageAssets/Team/Nee.png';
import Madiha from '../../Assets/img/InvestorPageAssets/Team/Madiha.png';
import Pria from '../../Assets/img/InvestorPageAssets/Team/Pria.png';
import Tyler from '../../Assets/img/InvestorPageAssets/Team/Tyler.png';
import MobileImage from '../../Assets/img/InvestorPageAssets/Rectangle 6678.png';
import Loading from '../../Loading';
import { Helmet } from 'react-helmet';
const InvestorPage = () => {
	const [bundles, setBundles] = useState(false);
	const [navOne, setNavOne] = useState(false);
	const [navTwo, setNavTwo] = useState(false);
	const [navThree, setNavThree] = useState(false);
	const [navFour, setNavFour] = useState(true);
	const [exploreButton, setExploreButton] = useState(false);
	const [resources, setresources] = useState(false);
	const [isLoading, setIsLoading] = useState(true);
	const [FooterSelected, setFooterSelected] = useState(24);
	const [popUpHasBeenShown, setPopUpHasBeenShown] = useState(false);
	const [LoginMenuOpener, setLoginMenuOpener] = useState(false);
	const [LetsTalkOpener, setLetsTalkOpener] = useState(false);
	const [InvestorPopUp, setInvestorPopUp] = useState(true);
	const [switchSlide, setSwitchSlide] = useState(false);
	const [hasAlreadySubmitted, setHasAlreadySubmitted] = useState(false);
	const [showInvestorPopUpAgain, setShowInvestorPopUpAgain] = useState(false);
	const [showInvestorPopUpOnTimer, setShowInvestorPopUpOnTimer] =
		useState(false);
	const [isWideScreen, setIsWideScreen] = useState(window.innerWidth > 700);
	const videoRef = useRef<HTMLVideoElement | null>(null);
	const videoRefTeam = useRef<HTMLVideoElement | null>(null);
	const videoRefIntersector = useRef<HTMLDivElement | null>(null);

	// check for window resize
	useEffect(() => {
		setTimeout(() => {
			if (
				hasAlreadySubmitted != true &&
				showInvestorPopUpAgain != true &&
				InvestorPopUp != true
			) {
				setShowInvestorPopUpOnTimer(true);
			}
		}, 60500);
	}, [hasAlreadySubmitted, showInvestorPopUpAgain, InvestorPopUp]);
	useEffect(() => {
		const handleResize = () => {
			setIsWideScreen(window.innerWidth > 700);
		};

		// Add event listener for window resize
		window.addEventListener('resize', handleResize);

		// Cleanup the event listener when the component is unmounted
		return () => {
			window.removeEventListener('resize', handleResize);
		};
	}, []); // useEffect runs only on mount and unmount

	const handleMouseEnter = () => {
		// Use setTimeout to set switchSlide to true after 0.5 seconds
		setTimeout(() => {
			setSwitchSlide(true);
		}, 300); // 500 milliseconds = 0.5 seconds
	};
	const handleMouseLeave = () => {
		// Use setTimeout to set switchSlide to true after 0.5 seconds
		setTimeout(() => {
			setSwitchSlide(false);
		}, 300); // 500 milliseconds = 0.5 seconds
	};
	const handleMouseEnterTeamVideo = () => {
		if (videoRefTeam.current) {
			videoRefTeam.current.play();
		}
	};
	const handleMouseLeaveTeamVideo = () => {
		if (videoRefTeam.current) {
			videoRefTeam.current.pause();
		}
	};
	useEffect(() => {
		// Check if the videoRef is not null and the switchSlide state is true, then play the video
		if (videoRef.current && switchSlide) {
			videoRef.current.play();
		}
	}, [switchSlide]);
	const [showOverlay, setShowOverlay] = useState(false);
	const handleButtonClick = () => {
		setShowOverlay(true);
	};
	const handleCloseOverlay = () => {
		setShowOverlay(false);
	};
	interface ScrollToSectionProps {
		targetId: string;
		offset: number;
	}
	// hook to check when the user intersects with the 65+ members text, when in view, it shows the investor data modal if the modal was not used
	useEffect(() => {
		// Check if the section is in the viewport
		const isSectionInView = () => {
			const rect = videoRefIntersector.current?.getBoundingClientRect();
			return (
				rect &&
				rect.top >= 0 &&
				rect.bottom <=
					(window.innerHeight ||
						document.documentElement.clientHeight)
			);
		};
		// State variable to track whether the effect has run
		let hasEffectRun = false;

		// Function to handle the scroll event
		const handleScroll = () => {
			if (isSectionInView() && !hasEffectRun) {
				// Set hasAlreadySubmitted to true when the section is in view

				setShowInvestorPopUpAgain(true);
				// Update the flag so it stops firing
				hasEffectRun = true;
			}
		};

		// Attach the scroll event listener
		window.addEventListener('scroll', handleScroll);

		// Cleanup the event listener when the component is unmounted
		return () => {
			window.removeEventListener('scroll', handleScroll);
		};
	}, []);
	// function to smoothly scroll to specific sections, with an offset value in pixels
	const scrollToSection = (
		{ targetId, offset }: ScrollToSectionProps,
		e: React.MouseEvent<HTMLAnchorElement>
	) => {
		e.preventDefault();
		const targetElement = document.getElementById(targetId);
		if (targetElement) {
			const targetScrollPosition = targetElement.offsetTop - offset;
			window.scrollTo({
				top: targetScrollPosition,
				behavior: 'smooth',
			});
		}
	};
	useEffect(() => {
		// Simulate loading for 1 second
		const timer = setTimeout(() => {
			setIsLoading(false);
		}, 1200);

		// Clean up the timer on component unmount
		return () => clearTimeout(timer);
	}, []);
	const handleClickSupplyChain = (e: React.MouseEvent<HTMLAnchorElement>) => {
		scrollToSection({ targetId: 'SupplyChain', offset: 100 }, e);
	};
	const handleClickVision = (e: React.MouseEvent<HTMLAnchorElement>) => {
		scrollToSection({ targetId: 'Vision', offset: 160 }, e);
	};
	const handleClickConsumerModel = (
		e: React.MouseEvent<HTMLAnchorElement>
	) => {
		scrollToSection({ targetId: 'ConsumerModel', offset: 100 }, e);
	};
	const handleClickAdvantage = (e: React.MouseEvent<HTMLAnchorElement>) => {
		scrollToSection({ targetId: 'Advantage', offset: 100 }, e);
	};
	const handleClickResults = (e: React.MouseEvent<HTMLAnchorElement>) => {
		scrollToSection({ targetId: 'Results', offset: 100 }, e);
	};
	const handleClickTeam = (e: React.MouseEvent<HTMLAnchorElement>) => {
		scrollToSection({ targetId: 'Team', offset: 160 }, e);
	};
	return (
		<div
			id='home'
			className='w-full h-full pt-[80px] mt-[-80px] min-h-[700px]'>
			<Helmet>
				<title>Salesmrkt Investor Relations</title>
			</Helmet>
			<Loading isLoading={isLoading} />
			<NavBarInvestor />
			{showInvestorPopUpOnTimer &&
				!showInvestorPopUpAgain &&
				!hasAlreadySubmitted && (
					<InvestorData
						isOpen={InvestorPopUp}
						setIsOpen={setInvestorPopUp}
						hasAlreadySubmitted={hasAlreadySubmitted}
						setHasAlreadySubmitted={setHasAlreadySubmitted}
						showInvestorPopUpAgain={showInvestorPopUpAgain}
						setShowInvestorPopUpAgain={setShowInvestorPopUpAgain}
						setShowInvestorPopUpOnTimer={
							setShowInvestorPopUpOnTimer
						}
					/>
				)}
			{InvestorPopUp && (
				<InvestorData
					isOpen={InvestorPopUp}
					setIsOpen={setInvestorPopUp}
					hasAlreadySubmitted={hasAlreadySubmitted}
					setHasAlreadySubmitted={setHasAlreadySubmitted}
					showInvestorPopUpAgain={showInvestorPopUpAgain}
					setShowInvestorPopUpAgain={setShowInvestorPopUpAgain}
					setShowInvestorPopUpOnTimer={setShowInvestorPopUpOnTimer}
				/>
			)}
			{!InvestorPopUp &&
				showInvestorPopUpAgain &&
				!hasAlreadySubmitted && (
					<InvestorData
						isOpen={InvestorPopUp}
						setIsOpen={setInvestorPopUp}
						hasAlreadySubmitted={hasAlreadySubmitted}
						setHasAlreadySubmitted={setHasAlreadySubmitted}
						showInvestorPopUpAgain={showInvestorPopUpAgain}
						setShowInvestorPopUpAgain={setShowInvestorPopUpAgain}
						setShowInvestorPopUpOnTimer={
							setShowInvestorPopUpOnTimer
						}
					/>
				)}

			<div className='w-full`  '>
				<div
					onClick={handleButtonClick}
					className='relative group w-full cursor-pointer overflow-hidden md:h-full mt-[80px]  md:min-h-[550px] lg:min-h-[700px]'>
					<div
						onClick={handleButtonClick}
						className='absolute hidden  md:flex  z-50   bottom-[50px] pl-4 md:pl-16 cursor-pointer    opacity-100 gap-3 items-center justify-center '>
						{/* Larger screen play button */}
						<div className=' relative transition-all ease-in-out duration-300 '>
							<svg
								width='72'
								height='72'
								viewBox='0 0 72 71'
								fill='none'
								className='hidden md:flex'
								xmlns='http://www.w3.org/2000/svg'>
								<path
									className='group-hover:drawn  group-hover:stroke-lime-500 stroke-black transition-all ease-in-out duration-300 '
									d='M28.3666 35.4769C28.3666 38.8059 28.3666 42.1349 28.3666 45.464C28.3666 47.3134 29.3969 47.8683 31.036 46.9435C34.8761 44.7704 38.7162 42.5973 42.5563 40.3779C44.6168 39.222 46.6774 38.0661 48.6911 36.864C50.0492 36.078 50.0492 34.8758 48.6911 34.0436C48.5974 33.9973 48.4569 33.9048 48.3633 33.8586C42.6031 30.5758 36.7961 27.293 31.036 24.0102C29.3969 23.0855 28.4134 23.6404 28.3666 25.4898C28.3666 28.8651 28.3666 32.1941 28.3666 35.4769Z'
									stroke='white'
									strokeWidth='3'
									strokeMiterlimit='10'
								/>
								<circle
									className=' group-hover:stroke-lime-500 stroke-black  transition-all ease-in-out duration-300 '
									cx='36'
									cy='36'
									r='32.5'
									stroke='white'
									strokeWidth='3'
								/>
							</svg>
							<svg
								width='42'
								height='42'
								viewBox='0 0 72 71'
								className='flex md:hidden'
								fill='none'
								xmlns='http://www.w3.org/2000/svg'>
								<path
									className='group-hover:drawn group-hover:stroke-lime-500 stroke-black transition-all ease-in-out duration-300 '
									d='M28.3666 35.4769C28.3666 38.8059 28.3666 42.1349 28.3666 45.464C28.3666 47.3134 29.3969 47.8683 31.036 46.9435C34.8761 44.7704 38.7162 42.5973 42.5563 40.3779C44.6168 39.222 46.6774 38.0661 48.6911 36.864C50.0492 36.078 50.0492 34.8758 48.6911 34.0436C48.5974 33.9973 48.4569 33.9048 48.3633 33.8586C42.6031 30.5758 36.7961 27.293 31.036 24.0102C29.3969 23.0855 28.4134 23.6404 28.3666 25.4898C28.3666 28.8651 28.3666 32.1941 28.3666 35.4769Z'
									stroke='white'
									strokeWidth='3'
									strokeMiterlimit='10'
								/>
								<circle
									className=' group-hover:stroke-lime-500 stroke-black  transition-all ease-in-out duration-300 '
									cx='36'
									cy='36'
									r='32.5'
									stroke='white'
									strokeWidth='3'
								/>
							</svg>
						</div>
						{showOverlay && !showInvestorPopUpAgain && (
							<div>
								<YouTubeEmbed
									videoId='9vKzzf3QKvE'
									onClose={handleCloseOverlay}
								/>
							</div>
						)}
						<h4 className='opacity-100 relative text-black   group-hover:text-lime-500 transition-all ease-in-out duration-300  hashTag textshadow font-semibold mt-1 text-base md:text-xl lg:text-2xl  drop-shadow-lg shadow-black'>
							Play
						</h4>
					</div>
					{isWideScreen && (
						<video
							muted
							autoPlay
							loop
							playsInline
							disablePictureInPicture
							preload={'auto'}
							className='w-full hidden md:flex absolute left-[100px] md:left-[280px] h-[60vh]  md:h-[85vh] -z-10  '
							src={BGVideoTN}
						/>
					)}

					<div className=' p-4 md:absolute   md:pl-16  md:w-2/3 flex md:block flex-col items-center justify-center gap-10  z-30  top-[50%] md:top-[20vh]'>
						<div className='flex  flex-col  '>
							<h2 className=' text-3xl text-center md:text-start  md:text-4xl lg:text-5xl 2xl:text-7xl font-bold  text-black   '>
								The Amazon of
							</h2>
							<h2 className='text-5xl text-center md:text-start  md:text-5xl lg:text-7xl 2xl:text-9xl font-bold text-[#8DC63F]   '>
								B2B Services
							</h2>
							<img
								src={MobileImage}
								alt=''
								className=' flex md:hidden w-full object-cover'
							/>
							<div className='mt-2'>
								<p className=' hidden md:flex 2xl:text-[1.9rem] text-lg md:text-2xl font-medium text-black '>
									All-in-One B2B marketplace for
									enterprise-grade
								</p>
								<p className='hidden md:flex 2xl:text-[1.9rem] text-xl md:text-2xl font-medium text-black '>
									sales, marketing & tech solutions
								</p>
								<p className=' 2xl:text-[1.9rem] mt-3 text-start  flex md:hidden text-2xl md:text-2xl font-normal md:font-medium  text-black '>
									All-in-One B2B marketplace for
									enterprise-grade sales, marketing & tech
									solutions
								</p>

								<a
									target='_blank'
									rel='noopener noreferrer'
									href='https://wefunder.com/salesmrkt'
									className='text-xl md:hidden text-center flex items-center justify-center mt-6 w-full text-lime-500 text font-semibold'>
									Invest Today {'>'}
								</a>
							</div>
						</div>
					</div>
				</div>
				<div className='flex items-start justify-between w-[98%]   '>
					<div className='w-full mt-0 2xl:mt-16 flex flex-col  items-center justify-center'>
						<ul className=' hidden xl:flex flex-wrap items-center justify-center mb-10 gap-6 16xl:gap-10 border-b-[1px] 16xl:mr-[200px]  '>
							<a
								onClick={handleClickVision}
								href='#Vision'
								className='font-semibold text-lg 2xl:text-xl hover:text-lime-500 transition-all duration-200'>
								Vision
							</a>
							<a
								onClick={handleClickSupplyChain}
								href='#SupplyChain'
								className='font-semibold text-lg 2xl:text-xl hover:text-lime-500 transition-all duration-200'>
								Service Supply Chain
							</a>
							<a
								onClick={handleClickConsumerModel}
								href='#ConsumerModel'
								className='font-semibold text-lg 2xl:text-xl hover:text-lime-500 transition-all duration-200'>
								Marketplace
							</a>
							<a
								onClick={handleClickAdvantage}
								href='#Advantage'
								className='font-semibold text-lg 2xl:text-xl hover:text-lime-500 transition-all duration-200'>
								First-Mover Advantage
							</a>
							<a
								onClick={handleClickResults}
								href='#Results'
								className='font-semibold text-lg 2xl:text-xl hover:text-lime-500 transition-all duration-200'>
								Track Record
							</a>
							<a
								onClick={handleClickTeam}
								href='#Team'
								className='font-semibold text-lg 2xl:text-xl hover:text-lime-500 transition-all duration-200'>
								Team
							</a>
						</ul>
						<div className='w-[90%] relative flex flex-col items-center gap-6 justify-center mt-16'>
							{/* <SectionSlider /> */}

							<div className='flex flex-col 2xl:flex-row items-center justify-center'>
								<h1 className='text-black flex md:hidden  text-3xl lg:text-5xl  mb-6 font-bold'>
									The Problem
								</h1>
								<div className='w-full flex 2xl:hidden mb-6'>
									<img
										src={SecondSectionImage}
										alt=''
									/>
								</div>
								<div className='2xl:w-1/2 flex flex-col gap-6 md:gap-3'>
									<h1 className='text-black hidden md:flex  text-3xl lg:text-5xl mt-6 md:mb-6 font-bold'>
										The Problem
									</h1>
									<div className='flex border rounded-lg p-2 md:border-none md:p-0 items-center gap-6 justify-center'>
										<div>
											<svg
												width='30'
												height='30'
												viewBox='0 0 54 56'
												fill='none'
												xmlns='http://www.w3.org/2000/svg'>
												<path
													d='M25.4077 43.4725C23.6816 43.4725 22.1627 43.4725 20.6092 43.4725C15.5001 43.4375 12.7384 40.6404 12.7384 35.4659C12.7384 34.6617 12.7384 33.8576 12.7384 32.7737C10.7016 32.7737 8.80294 32.8436 6.86975 32.7737C2.93431 32.6339 0 29.5221 0 25.5363C0 21.5505 3.00336 18.5087 6.97331 18.4388C8.38869 18.4038 9.83858 18.4388 11.254 18.4388C11.8063 18.4388 12.3932 18.4388 12.98 18.4388C14.499 14.7327 17.2607 13.2992 21.058 13.4041C24.0959 13.474 25.4767 12.0055 25.3732 8.89381C25.2696 5.71215 25.891 2.77524 28.8944 1.30678C32.4846 -0.441377 36.3855 -0.406414 40.0102 1.23686C42.5648 2.39065 43.635 4.87304 43.635 7.70506C43.6695 11.2014 43.635 14.6977 43.635 18.4388C44.7397 18.4388 45.7408 18.4388 46.7419 18.4388C50.8154 18.5087 53.8188 21.4107 53.9223 25.5713C54.0259 29.1725 54.0259 32.8087 53.9223 36.4099C53.8188 40.6055 50.8154 43.4375 46.5348 43.4725C41.322 43.5424 36.1093 43.4725 30.8966 43.4725C30.2752 43.4725 29.6538 43.4725 28.8944 43.4725C28.8944 45.6052 28.7563 47.5981 28.9289 49.5561C29.067 51.3392 30.6549 52.423 32.6572 52.458C38.2496 52.493 43.8766 52.458 49.4691 52.458C49.9179 52.458 50.5047 52.2832 50.8154 52.5279C51.4713 53.0174 51.9546 53.7167 52.5415 54.346C51.9546 54.8705 51.4368 55.8145 50.7809 55.8844C48.9858 56.0942 47.1216 55.9543 45.292 55.9543C41.2185 55.9543 37.1795 55.9543 33.106 55.9543C28.1694 55.9543 25.4077 53.0873 25.3732 48.0177C25.4077 46.6191 25.4077 45.2206 25.4077 43.4725ZM28.8253 39.9412C35.0737 39.9412 41.0804 39.9761 47.0871 39.9062C48.9858 39.8712 50.3666 38.4727 50.4357 36.5847C50.5392 32.8436 50.5392 29.1375 50.4357 25.3965C50.4012 23.6133 49.0893 22.1798 47.5014 22.005C46.2586 21.8652 45.0158 21.9701 43.704 21.9701C43.704 23.5434 43.704 25.0119 43.704 27.0048C44.498 25.2566 45.3956 24.1028 46.9145 24.9769C48.606 25.9209 47.8121 27.3544 47.2252 28.648C46.155 31.0255 45.1539 33.438 43.9457 35.7456C43.5314 36.5148 42.6339 37.4937 41.9434 37.5287C41.2875 37.5637 40.3209 36.5847 39.9067 35.8155C38.5949 33.2982 37.4902 30.6759 36.2819 28.0886C35.6951 26.83 35.2808 25.5713 36.7997 24.7671C38.3187 23.963 39.1127 25.0468 39.6995 26.3055C39.7341 26.3754 39.9067 26.3754 40.0102 26.4104C40.0102 24.9419 40.0102 23.4735 40.0102 22.04C32.0013 22.04 24.1304 22.04 16.2941 22.04C16.2941 24.5224 16.2941 26.8649 16.2941 29.2774C18.0892 29.2774 19.7462 29.2774 21.4032 29.2774C25.7529 29.3473 28.6527 32.2493 28.8253 36.5847C28.8598 37.6336 28.8253 38.6825 28.8253 39.9412ZM17.1916 17.5997C17.2261 17.8444 17.2607 18.0891 17.2952 18.2989C24.8554 18.2989 32.4155 18.2989 40.1828 18.2989C40.1828 15.5718 40.1138 12.9845 40.1828 10.3623C40.39 4.97793 39.596 3.43954 33.6238 3.68429C29.8955 3.8591 28.9634 4.80311 28.7563 8.57914C28.6527 10.3623 28.2385 12.3202 27.3754 13.8586C26.0291 16.306 23.509 16.9004 20.8509 16.9354C19.6426 16.9703 18.3999 17.3899 17.1916 17.5997ZM12.6693 21.9351C10.5981 21.9351 8.69938 21.8652 6.83522 21.9351C4.97107 22.005 3.59022 23.4036 3.45213 25.2216C3.31405 27.1446 4.48777 28.9277 6.35193 29.1375C8.42321 29.3473 10.529 29.1725 12.6693 29.1725C12.6693 26.76 12.6693 24.4525 12.6693 21.9351ZM16.1905 32.8087C16.1905 34.2072 16.0869 35.4309 16.225 36.6546C16.3631 38.3329 17.2952 39.6265 18.9522 39.8013C21.0235 40.0111 23.1293 39.8712 25.4077 39.8712C25.4077 38.6825 25.4767 37.5637 25.4077 36.4798C25.2696 34.2072 23.8197 32.8786 21.6104 32.8087C19.8843 32.7737 18.1582 32.8087 16.1905 32.8087Z'
													fill='#84CC16'
												/>
											</svg>
										</div>
										<div>
											<h3 className='text-black text-xl font-bold mb-1'>
												Buying & Selling Services is
												Over Complicated
											</h3>
											<p className='text-base'>
												B2B transactions require an
												expensive, time consuming and
												difficult sales process where
												the burden of high cost is
												ultimately shared between both
												the buyer and the seller.
											</p>
										</div>
									</div>
									<div className='flex border rounded-lg p-2 md:border-none md:p-0 items-center gap-6 justify-center'>
										<div>
											<svg
												width='30'
												height='30'
												viewBox='0 0 58 48'
												fill='none'
												xmlns='http://www.w3.org/2000/svg'>
												<path
													d='M50.0103 17.0904C47.2137 17.0904 46.0265 19.7012 45.0259 18.7507C44.1676 17.9354 44.2175 17.5305 44.4928 15.4995L45.6283 5.46124C46.0228 3.27886 44.515 1.95738 43.2271 2.00106C43.2271 2.00106 35.0237 2.32708 33.8191 2.32708C32.6142 2.32708 31.89 3.16037 32.3723 4.27297C32.8554 5.38448 34.8686 7.05642 35.0229 9.55108C35.264 13.4418 32.3723 16.7773 29 16.7773C25.6278 16.7773 22.736 13.4419 22.9771 9.55108C23.1314 7.05642 25.1445 5.38448 25.6277 4.27297C26.1099 3.16049 25.3856 2.32708 24.1809 2.32708C22.976 2.32708 14.7728 2.00106 14.7728 2.00106C13.4849 1.95726 11.9771 3.27874 12.3716 5.46124L13.5071 15.4995C13.7824 17.5316 13.8323 17.9366 12.974 18.7507C11.9733 19.7012 10.7862 17.0904 7.98957 17.0904C4.68291 17.0904 2 20.1849 2 23.9999C2 27.8149 4.68291 30.9096 7.98957 30.9096C10.7863 30.9096 11.9734 28.2988 12.974 29.2493C13.8323 30.0646 13.7824 30.4695 13.5071 32.5007L12.3716 42.5389C11.9771 44.7213 13.4849 46.0426 14.7728 45.999C14.7728 45.999 22.9762 45.6729 24.1809 45.6729C25.3856 45.6729 26.1099 44.8395 25.6277 43.727C25.1445 42.6155 23.1313 40.9436 22.9771 38.4488C22.7359 34.5582 25.6277 31.2229 29 31.2229C32.3723 31.2229 35.264 34.5582 35.0229 38.4488C34.8686 40.9436 32.8554 42.6155 32.3723 43.727C31.89 44.8395 32.6143 45.6729 33.8191 45.6729C35.0237 45.6729 43.2271 45.999 43.2271 45.999C44.515 46.0426 46.0229 44.7213 45.6283 42.5389L44.4928 32.5007C44.2176 30.4685 44.1676 30.0635 45.0259 29.2493C46.0265 28.2988 47.2137 30.9096 50.0103 30.9096C53.317 30.9096 56 27.8149 56 23.9999C56 20.1849 53.317 17.0904 50.0103 17.0904Z'
													stroke='#84CC16'
													stroke-width='4'
												/>
											</svg>
										</div>
										<div>
											<h3 className='text-black text-xl font-bold mb-1'>
												Vendors Only Solve One Piece of
												the Puzzle
											</h3>
											<p className='text-base'>
												Service providers rarely excel
												at solving more than one part of
												the sales & marketing equation,
												forcing buyers to cobble
												together a patchwork of
												solutions for multiple vendors.
											</p>
										</div>
									</div>
									<div className='flex border rounded-lg p-2 md:border-none md:p-0 items-center gap-6 justify-center'>
										<div>
											<svg
												width='30'
												height='30'
												viewBox='0 0 58 40'
												fill='none'
												xmlns='http://www.w3.org/2000/svg'>
												<path
													d='M41.5565 2C40.3578 2 39.2212 2.2701 38.2031 2.75113C38.5919 3.25188 38.9412 3.78491 39.2453 4.34588C39.5436 4.896 39.7984 5.47311 40.0062 6.07173C40.4204 7.26571 40.6462 8.54692 40.6462 9.88001C40.6462 11.213 40.4204 12.4943 40.0062 13.6882C39.7985 14.287 39.5436 14.8638 39.2453 15.414C38.9412 15.975 38.592 16.5079 38.2031 17.0088C39.2212 17.4897 40.3578 17.76 41.5565 17.76C45.9016 17.7602 49.4365 14.2252 49.4365 9.88022C49.4365 5.53491 45.9016 2 41.5565 2Z'
													stroke='#84CC16'
													stroke-width='3'
												/>
												<path
													d='M41.5608 21.5275C41.0946 21.5275 40.6298 21.5505 40.168 21.5951C40.8872 22.1552 41.564 22.7673 42.1915 23.4269C42.8249 24.0925 43.4076 24.8063 43.9353 25.5612C45.6596 28.0277 46.7899 30.9386 47.1147 34.0853C47.1787 34.7047 47.2117 35.333 47.2117 35.9689C47.2117 36.6293 47.0968 37.263 46.8877 37.8526H54.1185C55.1588 37.8526 56.0021 37.009 56.0021 35.9689C56.0022 28.0058 49.5238 21.5275 41.5608 21.5275Z'
													stroke='#84CC16'
													stroke-width='3'
												/>
												<path
													d='M17.989 13.6885C17.5747 12.4946 17.3489 11.2133 17.3489 9.88028C17.3489 8.54719 17.5747 7.26599 17.989 6.072C18.1968 5.47296 18.4515 4.89606 18.7498 4.34594C19.0539 3.78497 19.4031 3.25205 19.792 2.75119C18.7739 2.27027 17.6373 2.00006 16.4386 2.00006C12.0935 2.00006 8.55859 5.53497 8.55859 9.88007C8.55859 14.2251 12.0935 17.7601 16.4386 17.7601C17.6373 17.7601 18.7739 17.4899 19.792 17.0088C19.4033 16.508 19.0539 15.9751 18.7498 15.4141C18.4515 14.8641 18.1967 14.2872 17.989 13.6885Z'
													stroke='#84CC16'
													stroke-width='3'
												/>
												<path
													d='M16.4415 21.5274C8.47847 21.5274 2 28.0058 2 35.9689C2 37.0091 2.84341 37.8525 3.88363 37.8525H11.1144C10.9055 37.2629 10.7905 36.6291 10.7905 35.9689C10.7905 35.3328 10.8235 34.7046 10.8874 34.0853C11.2123 30.9386 12.3425 28.0276 14.0668 25.5612C14.5947 24.8062 15.1773 24.0924 15.8106 23.4268C16.4381 22.7673 17.1149 22.1551 17.8342 21.595C17.3724 21.5504 16.9076 21.5274 16.4415 21.5274Z'
													stroke='#84CC16'
													stroke-width='3'
												/>
												<path
													d='M36.3158 6.96387C36.0512 6.30249 35.7008 5.68457 35.2762 5.12528C33.8359 3.22815 31.5578 2 28.9973 2C26.4368 2 24.1587 3.22815 22.7184 5.12549C22.2938 5.68478 21.9434 6.3027 21.6788 6.96408C21.318 7.86676 21.1172 8.85013 21.1172 9.88011C21.1172 10.91 21.318 11.8934 21.6788 12.796C21.9434 13.4574 22.2938 14.0753 22.7184 14.6346C24.1587 16.5318 26.4368 17.76 28.9973 17.76C31.5578 17.76 33.8359 16.5318 35.2762 14.6344C35.7008 14.0751 36.0512 13.4572 36.3158 12.7958C36.6766 11.8931 36.8774 10.9099 36.8774 9.8799C36.8774 8.84992 36.6766 7.86655 36.3158 6.96387Z'
													stroke='#84CC16'
													stroke-width='3'
												/>
												<path
													d='M43.3186 34.0852C42.8851 30.7733 41.3252 27.8112 39.0373 25.5963C38.4955 25.072 37.9134 24.5894 37.2955 24.1544C36.6581 23.7055 35.9831 23.3064 35.2759 22.9639C33.9163 22.3051 32.4384 21.8535 30.8836 21.6501C30.8836 35.145 27.1163 37.1074 27.1163 21.6501C25.5615 21.8535 24.0837 22.3051 22.7239 22.9639C22.0167 23.3065 21.3418 23.7055 20.7043 24.1544C20.0864 24.5895 19.5041 25.0721 18.9625 25.5963C16.6745 27.8111 15.1146 30.7733 14.6813 34.0852C14.6007 34.7017 14.5586 35.3304 14.5586 35.9688C14.5586 37.009 15.402 37.8524 16.4422 37.8524H41.5579C42.5982 37.8524 43.4415 37.0089 43.4415 35.9688C43.4414 35.3304 43.3994 34.7017 43.3186 34.0852Z'
													stroke='#84CC16'
													stroke-width='3'
												/>
											</svg>
										</div>
										<div>
											<h3 className='text-black text-xl font-bold mb-1 w-full '>
												The Market is Oversaturated
											</h3>
											<p className='text-base'>
												Buyers struggle to find the
												right solutions in a cluttered
												market, while service providers
												compete to differentiate their
												offers.
											</p>
										</div>
									</div>
								</div>
								<div className='w-1/2 hidden 2xl:flex'>
									<img
										src={SecondSectionImage}
										alt='Buying & Selling Services is Over Complicated '
										className='max-h-[600px]'
									/>
								</div>
							</div>
							<div
								onMouseEnter={handleMouseEnter}
								onMouseLeave={handleMouseLeave}
								className='flex flex-col 2xl:flex-row items-center justify-center md:mt-10'>
								<h1 className='text-lime-500 flex md:hidden text-center md:text-start text-4xl lg:text-6xl 2xl:text-8xl mb-6 mt-10 md:mt-0 font-bold'>
									The Solution
								</h1>
								<div className='2xl:w-1/2'>
									<video
										muted
										ref={videoRef}
										controls={false}
										src={SolutionVideo}
										className='w-full hidden md:flex max-h-[600px]'
									/>
									<video
										muted
										autoPlay
										loop
										playsInline
										disablePictureInPicture
										preload={'auto'}
										controls={false}
										src={SolutionVideo}
										className='w-full aspect-square flex md:hidden mb-6 '
									/>
								</div>
								<div className='2xl:w-1/2 flex flex-col gap-6 md:gap-3'>
									<h1 className='text-lime-500 hidden md:flex text-center md:text-start 2xl:text-8xl mb-6 mt-10 md:mt-0 font-bold'>
										The Solution
									</h1>
									<div className='flex border rounded-lg p-2 md:border-none md:p-0 items-center gap-6 justify-center'>
										<div>
											<svg
												width='30'
												height='30'
												viewBox='0 0 94 93'
												fill='none'
												xmlns='http://www.w3.org/2000/svg'>
												<path
													d='M75.2887 75.7681C75.0975 75.3003 74.9904 74.7865 74.9904 74.2497C74.9904 73.7129 75.0975 73.1991 75.2887 72.7313C75.4876 72.2635 75.7707 71.834 76.1226 71.4812L76.1455 71.4506C76.3444 71.2512 76.5739 71.0595 76.8187 70.9137C76.9487 70.8294 77.0864 70.7527 77.2394 70.6837V64.3799H70.7295C70.5306 65.7603 69.8727 67.0026 68.9242 67.9613C67.7384 69.1499 66.0938 69.8861 64.2808 69.8861H60.3564V87.0797H71.8693C71.9305 86.98 71.9917 86.8803 72.0605 86.7806C72.1982 86.5812 72.3512 86.3971 72.5195 86.2284C72.8791 85.868 73.3151 85.5689 73.8047 85.3695C74.2713 85.1778 74.7839 85.0704 75.3193 85.0704C75.8472 85.0704 76.3674 85.1778 76.834 85.3695C77.3236 85.5689 77.752 85.868 78.1191 86.2284C78.4787 86.5889 78.777 87.026 78.9759 87.5168C79.1672 87.9846 79.2743 88.4984 79.2743 89.0352C79.2743 89.5644 79.1672 90.0705 78.9759 90.5536C78.777 91.0444 78.4787 91.4816 78.1191 91.842C77.7596 92.2024 77.3236 92.5015 76.834 92.7009C76.3674 92.8926 75.8548 93 75.3193 93C74.7992 93 74.3019 92.9003 73.8353 92.7086L73.8047 92.7009C73.3151 92.5015 72.8867 92.2024 72.5195 91.842C72.2977 91.6196 72.0988 91.3589 71.9305 91.0905C71.8387 90.9371 71.7546 90.7684 71.6857 90.6073H58.597C58.1074 90.6073 57.6714 90.4079 57.3501 90.0858C57.0212 89.7561 56.8223 89.319 56.8223 88.8282V69.8861H48.2546V85.4845C48.3846 85.5536 48.5147 85.6226 48.6447 85.7069C48.8818 85.8526 49.1037 86.0367 49.2949 86.2284C49.6621 86.5965 49.9528 87.026 50.1517 87.5168C50.3429 87.9846 50.45 88.4984 50.45 89.0352C50.45 89.5567 50.3506 90.0552 50.1593 90.523L50.1517 90.5536C49.9528 91.0444 49.6545 91.4739 49.2949 91.842C48.9354 92.2024 48.4994 92.5015 48.0098 92.7009C47.5431 92.8926 47.0306 93 46.4951 93C45.9673 93 45.4548 92.8926 44.9805 92.7009C44.4909 92.5015 44.0549 92.2024 43.6953 91.842C43.3358 91.4816 43.0374 91.0444 42.8385 90.5536C42.6473 90.0858 42.5402 89.572 42.5402 89.0352C42.5402 88.5137 42.6397 88.0153 42.8309 87.5475L42.8385 87.5168C43.0374 87.026 43.3358 86.5965 43.6953 86.2284C43.8866 86.0367 44.0931 85.868 44.3226 85.7223L44.3532 85.6993C44.4756 85.6302 44.6056 85.5612 44.7357 85.4922V69.8861H33.307V77.9691C33.307 78.4599 33.1081 78.897 32.7868 79.2191C32.4655 79.5412 32.0295 79.7406 31.5399 79.7406H23.4312C23.37 79.8633 23.3011 79.9783 23.2246 80.101C23.0869 80.3081 22.9263 80.5075 22.7427 80.6915L22.7121 80.7222C22.3525 81.0826 21.9165 81.3817 21.4269 81.5811C20.9603 81.7728 20.4478 81.8802 19.9123 81.8802C19.3921 81.8802 18.8949 81.7805 18.4282 81.5888L18.3976 81.5811C17.908 81.3817 17.4797 81.0826 17.1125 80.7222C16.7529 80.3618 16.4546 79.9246 16.2557 79.4338C16.0645 78.966 15.9574 78.4522 15.9574 77.9154C15.9574 77.3862 16.0645 76.8724 16.2557 76.397C16.4546 75.9062 16.7529 75.469 17.1125 75.1086C17.4873 74.7558 17.931 74.4568 18.4206 74.2574C18.8872 74.0656 19.3997 73.9583 19.9352 73.9583C20.4707 73.9583 20.9832 74.0656 21.4499 74.2574C21.9165 74.4568 22.3449 74.7405 22.6968 75.1009L22.7274 75.1239C22.9263 75.3233 23.1175 75.5534 23.2629 75.7988C23.3394 75.9292 23.4235 76.0672 23.4924 76.2206H29.7804V69.7404C28.5335 69.4643 27.4167 68.8355 26.5522 67.9689C25.3971 66.8109 24.6857 65.2311 24.6857 63.498V59.2878H5.91325V70.8294C6.0127 70.8907 6.11214 70.9521 6.21159 71.0211C6.41048 71.1591 6.58643 71.3125 6.76237 71.4812C7.12191 71.8417 7.42025 72.2788 7.61914 72.7696C7.81038 73.2374 7.91748 73.7512 7.91748 74.288C7.91748 74.8172 7.81038 75.3387 7.61914 75.8065C7.42025 76.2973 7.12191 76.7267 6.76237 77.0948C6.40283 77.4553 5.9668 77.7544 5.47721 77.9537C5.01058 78.1455 4.49805 78.2528 3.96257 78.2528C3.43473 78.2528 2.92985 78.1455 2.44792 77.9537C1.95833 77.7544 1.5223 77.4553 1.16276 77.0948C0.803223 76.7344 0.504883 76.2973 0.30599 75.8065C0.107096 75.3233 0 74.8095 0 74.2727C0 73.7512 0.0994466 73.2527 0.29069 72.785L0.29834 72.7543C0.497233 72.2635 0.795573 71.834 1.15511 71.4659C1.37695 71.2435 1.63704 71.0441 1.90479 70.8754C2.05013 70.7834 2.22607 70.699 2.38672 70.63V57.5163C2.38672 57.0255 2.58561 56.5884 2.9069 56.2663C3.23584 55.9365 3.67188 55.7371 4.16146 55.7371H24.6857V47.148H7.5044C7.43555 47.2784 7.3667 47.4088 7.28255 47.5391C7.13721 47.7769 6.95361 47.9993 6.76237 48.191C6.39518 48.5591 5.9668 48.8505 5.47721 49.0499C5.01058 49.2416 4.49805 49.349 3.96257 49.349C3.44238 49.349 2.94515 49.2493 2.47852 49.0576L2.44792 49.0499C1.95833 48.8505 1.52995 48.5514 1.16276 48.191C0.803223 47.8305 0.504883 47.3934 0.30599 46.9026C0.114746 46.4348 0.00764974 45.921 0.00764974 45.3842C0.00764974 44.855 0.114746 44.3412 0.30599 43.8658C0.504883 43.375 0.803223 42.9378 1.16276 42.5774C1.5223 42.217 1.95833 41.9179 2.44792 41.7185C2.9222 41.5191 3.42708 41.4117 3.97022 41.4117C4.4904 41.4117 4.98763 41.5114 5.45426 41.7031L5.48486 41.7108C5.97445 41.9102 6.40283 42.2093 6.77002 42.5697C6.96126 42.7614 7.12956 42.9685 7.28255 43.1986L7.3055 43.2292C7.37435 43.3519 7.4432 43.4823 7.51204 43.6127H24.6857V32.9453C24.6857 32.6846 24.701 32.4238 24.7316 32.1631H15.0011C14.5116 32.1631 14.0755 31.9637 13.7542 31.6416C13.4329 31.3195 13.234 30.8824 13.234 30.3916V22.2626C13.1117 22.2013 12.9969 22.1323 12.8745 22.0556C12.668 21.9175 12.4691 21.7565 12.2855 21.5724L12.2549 21.5418C11.8953 21.1813 11.597 20.7442 11.3981 20.2534C11.2069 19.7856 11.0998 19.2718 11.0998 18.735C11.0998 18.2135 11.1992 17.715 11.3905 17.2472L11.3981 17.2165C11.597 16.7257 11.8953 16.2963 12.2549 15.9282C12.6144 15.5677 13.0505 15.2687 13.54 15.0693C14.0067 14.8775 14.5192 14.7702 15.0547 14.7702C15.5825 14.7702 16.0951 14.8775 16.5693 15.0693C17.0589 15.2687 17.495 15.5677 17.8545 15.9282C18.2064 16.304 18.5047 16.7487 18.7036 17.2395C18.8949 17.7073 19.002 18.2212 19.002 18.758C19.002 19.2948 18.8949 19.8086 18.7036 20.2764C18.5047 20.7442 18.2217 21.1737 17.8698 21.5264L17.8468 21.5571C17.6479 21.7565 17.4185 21.9482 17.166 22.0939C17.036 22.1706 16.8983 22.255 16.7453 22.324V28.6278H26.3457V28.6738C26.4069 28.6048 26.4757 28.5357 26.5369 28.4744C27.7227 27.2857 29.3674 26.5495 31.1803 26.5495H34.8599V5.92801H23.3623C23.3011 6.02771 23.2399 6.1274 23.1711 6.2271C23.0334 6.42649 22.8804 6.60287 22.7121 6.77925C22.3525 7.13969 21.9165 7.43877 21.4269 7.63816C20.9603 7.82988 20.4478 7.93725 19.9123 7.93725C19.3844 7.93725 18.8643 7.82988 18.3976 7.63816C17.908 7.43877 17.4797 7.13969 17.1125 6.77925C16.7529 6.41882 16.4546 5.98169 16.2557 5.49089C16.0645 5.01542 15.9574 4.50928 15.9574 3.96479C15.9574 3.43564 16.0645 2.9295 16.2557 2.44636C16.4546 1.95555 16.7529 1.51843 17.1125 1.15799C17.472 0.797559 17.908 0.498474 18.3976 0.299085C18.8643 0.107364 19.3768 0 19.9123 0C20.4325 0 20.9297 0.0996949 21.3963 0.291416L21.4269 0.299085C21.9165 0.498474 22.3449 0.797559 22.7121 1.15799C22.9339 1.38039 23.1328 1.64113 23.3011 1.90954C23.3929 2.05525 23.4771 2.23163 23.5536 2.39268H36.627C37.1165 2.39268 37.5526 2.59207 37.8739 2.91416C38.2028 3.24392 38.4017 3.68104 38.4017 4.17185V26.5495H46.9694V7.52313C46.8394 7.45411 46.7093 7.38509 46.5793 7.30073C46.3421 7.15503 46.1203 6.97097 45.929 6.77925C45.5619 6.41115 45.2712 5.98169 45.0723 5.49089C44.881 5.02309 44.7739 4.50928 44.7739 3.97246C44.7739 3.45098 44.8734 2.9525 45.0646 2.4847L45.0723 2.45403C45.2712 1.96322 45.5695 1.53377 45.929 1.16566C46.2886 0.805228 46.7246 0.506143 47.2142 0.306754C47.6808 0.115033 48.1934 0.00766884 48.7288 0.00766884C49.2567 0.00766884 49.7692 0.115033 50.2435 0.306754C50.7331 0.506143 51.1691 0.805228 51.5286 1.16566C51.8882 1.5261 52.1865 1.96322 52.3854 2.45403C52.5767 2.92183 52.6838 3.43564 52.6838 3.97246C52.6838 4.49394 52.5843 4.99241 52.3931 5.46021L52.3854 5.49089C52.1865 5.98169 51.8882 6.41115 51.5286 6.77925C51.3374 6.97097 51.1309 7.13969 50.9014 7.29307L50.8708 7.31607C50.7484 7.38509 50.6183 7.45411 50.4883 7.52313V26.5419H61.9093V15.0386C61.9093 14.5478 62.1082 14.1107 62.4295 13.7886C62.7508 13.4665 63.1869 13.2671 63.6764 13.2671H71.7928C71.854 13.1444 71.9229 13.0294 71.9994 12.9067C72.137 12.6996 72.2977 12.5002 72.4813 12.3162L72.5119 12.2855C72.8714 11.925 73.3075 11.626 73.797 11.4266C74.2637 11.2348 74.7762 11.1275 75.3117 11.1275C75.8319 11.1275 76.3291 11.2272 76.7957 11.4189L76.8263 11.4266C77.3159 11.626 77.7443 11.925 78.1115 12.2855C78.471 12.6459 78.7694 13.083 78.9683 13.5738C79.1595 14.0416 79.2666 14.5555 79.2666 15.0923C79.2666 15.6214 79.1595 16.1352 78.9683 16.6107C78.7694 17.1015 78.471 17.5386 78.1115 17.8991C77.729 18.2518 77.293 18.5509 76.8034 18.7503C76.3368 18.942 75.8242 19.0494 75.2887 19.0494C74.7533 19.0494 74.2407 18.942 73.7741 18.7503C73.3075 18.5509 72.8791 18.2672 72.5272 17.9144L72.4966 17.8914C72.2977 17.692 72.1064 17.4619 71.9611 17.2165C71.877 17.0862 71.8005 16.9481 71.7316 16.7948H65.4435V26.6415C66.7975 26.8793 68.0062 27.5388 68.9318 28.4667C70.0869 29.6247 70.7983 31.2045 70.7983 32.9377V33.7276H88.0868V22.1859C87.9873 22.1246 87.8879 22.0632 87.7884 21.9942C87.5895 21.8562 87.4136 21.7028 87.2453 21.5341C86.8857 21.1737 86.5874 20.7365 86.3885 20.2457C86.1973 19.7779 86.0902 19.2641 86.0902 18.7273C86.0902 18.1982 86.1973 17.6767 86.3885 17.2089C86.5874 16.7181 86.8857 16.2886 87.2453 15.9205C87.6048 15.5601 88.0409 15.261 88.5304 15.0616C88.9971 14.8699 89.5096 14.7625 90.0451 14.7625C90.5729 14.7625 91.0855 14.8699 91.5597 15.0616C92.0493 15.261 92.4854 15.5601 92.8449 15.9205C93.2044 16.2809 93.5028 16.7181 93.7017 17.2089C93.8929 17.6767 94 18.1905 94 18.7273C94 19.2488 93.9006 19.7473 93.7093 20.2151L93.7017 20.2457C93.5028 20.7365 93.2044 21.166 92.8449 21.5341C92.6231 21.7565 92.363 21.9559 92.0952 22.1246C91.9422 22.2166 91.7739 22.301 91.6133 22.3777V35.4837C91.6133 35.9745 91.4144 36.4116 91.0931 36.7337C90.7642 37.0635 90.3281 37.2629 89.8385 37.2629H70.7983V45.852H86.4956C86.5645 45.7216 86.6333 45.5912 86.7175 45.4609C86.8704 45.2231 87.0464 45.0007 87.2376 44.809C87.6048 44.4409 88.0332 44.1495 88.5228 43.9501C88.9894 43.7584 89.502 43.651 90.0374 43.651C90.5576 43.651 91.0549 43.7507 91.5215 43.9424L91.5521 43.9501C92.0417 44.1495 92.4701 44.4486 92.8372 44.809C93.1968 45.1695 93.4951 45.6066 93.694 46.0974C93.8853 46.5652 93.9924 47.079 93.9924 47.6158C93.9924 48.145 93.8853 48.6588 93.694 49.1342C93.4951 49.6251 93.1968 50.0622 92.8372 50.4226C92.4777 50.783 92.0417 51.0821 91.5521 51.2815C91.0855 51.4732 90.5729 51.5806 90.0374 51.5806C89.5173 51.5806 89.02 51.4809 88.5534 51.2892L88.5228 51.2815C88.0332 51.0821 87.6048 50.783 87.2376 50.4226C87.0464 50.2309 86.8781 50.0238 86.7251 49.7938L86.7021 49.7631C86.6333 49.6404 86.5645 49.51 86.4956 49.3797H70.7983V60.8292H78.9989C79.4884 60.8292 79.9245 61.0286 80.2458 61.3507C80.5671 61.6728 80.766 62.1099 80.766 62.6007V70.7374C80.8884 70.7987 81.0031 70.8677 81.1255 70.9521C81.332 71.0901 81.5309 71.2512 81.7145 71.4352L81.7451 71.4659C82.1047 71.8263 82.403 72.2635 82.6019 72.7543C82.7931 73.2221 82.9002 73.7359 82.9002 74.2727C82.9002 74.7942 82.8008 75.2927 82.6095 75.7605L82.6019 75.7911C82.403 76.2819 82.1047 76.7114 81.7451 77.0795C81.3856 77.4399 80.9495 77.739 80.46 77.9384C79.9933 78.1301 79.4808 78.2375 78.9453 78.2375C78.4175 78.2375 77.905 78.1301 77.4307 77.9384C76.9411 77.739 76.5051 77.4399 76.1455 77.0795C75.7936 76.7037 75.4876 76.2589 75.2887 75.7681ZM40.9185 39.9853H54.5656C55.6289 39.9853 56.4933 40.8519 56.4933 41.9179V54.5178C56.4933 55.5837 55.6289 56.4503 54.5656 56.4503H40.9185C39.8551 56.4503 38.9907 55.5837 38.9907 54.5178V41.9179C38.9907 40.8519 39.8551 39.9853 40.9185 39.9853ZM64.2884 29.9698H31.188C30.4307 29.9698 29.7345 30.2842 29.2297 30.7981C28.6865 31.3425 28.3499 32.1018 28.3499 32.9453V63.4903C28.3499 64.3339 28.6865 65.0931 29.2297 65.6376C29.7422 66.1514 30.4307 66.4658 31.188 66.4658H64.2884C65.0457 66.4658 65.7419 66.1514 66.2467 65.6376C66.7899 65.0931 67.1265 64.3339 67.1265 63.4903V32.9453C67.1265 32.1018 66.7899 31.3425 66.2467 30.7981C65.7419 30.2842 65.0457 29.9698 64.2884 29.9698Z'
													fill='#8DC63F'
												/>
											</svg>
										</div>
										<div>
											<h3 className='text-black font-bold mb-1'>
												Cutting Edge Technology
											</h3>
											<p className='text-base'>
												All-in-One B2B Marketplace for
												sales, mark- eting & tech
												solutions. Salesmrkt eliminates
												the time, complexity &
												fragmentation in the current B2B
												sales model.
											</p>
										</div>
									</div>
									<div className='flex border rounded-lg p-2 md:border-none md:p-0 items-center gap-6 justify-center'>
										<div>
											<svg
												width='30'
												height='30'
												viewBox='0 0 103 96'
												fill='none'
												xmlns='http://www.w3.org/2000/svg'>
												<path
													d='M29.9195 57.1628C29.9195 57.8277 29.3793 58.3596 28.7227 58.3596C28.0578 58.3596 27.5259 57.8194 27.5259 57.1628V27.8501H2.39356V86.9244H6.54073C7.20561 86.9244 7.73751 87.4646 7.73751 88.1212C7.73751 88.7861 7.1973 89.318 6.54073 89.318H1.19678C0.531902 89.318 0 88.7778 0 88.1212V27.2101C0 26.7281 0.199463 26.2876 0.51528 25.9635C0.831097 25.6476 1.27158 25.4482 1.76193 25.4482H27.5259V2.10268C27.5259 1.52922 27.7586 0.997316 28.1409 0.623323V0.615012C28.5232 0.232707 29.0468 0 29.6286 0H72.3054C72.8872 0 73.4108 0.232707 73.7931 0.615012L73.8845 0.714743C74.2086 1.08874 74.4164 1.57077 74.4164 2.10268V25.4482H100.363C100.845 25.4482 101.286 25.6476 101.602 25.9635L101.61 25.9718C101.926 26.2876 102.125 26.7281 102.125 27.2101V88.1212C102.125 88.7861 101.585 89.318 100.928 89.318H93.3322C92.6673 89.318 92.1354 88.7778 92.1354 88.1212C92.1354 87.4563 92.6756 86.9244 93.3322 86.9244H99.7316V27.8501H74.4081V56.8138C74.4081 57.4787 73.8679 58.0106 73.2113 58.0106C72.5464 58.0106 72.0145 57.4704 72.0145 56.8138V2.39356H29.9195V57.1628ZM80.7411 56.9634H93.9555C94.0635 56.9634 94.155 57.0299 94.155 57.1047V61.0108C94.155 61.0939 94.0635 61.1604 93.9555 61.1604H80.7411C80.633 61.1604 80.5416 61.0939 80.5416 61.0108V57.1047C80.5416 57.0299 80.633 56.9634 80.7411 56.9634ZM8.06995 56.9634H21.2844C21.3924 56.9634 21.4839 57.0299 21.4839 57.1047V61.0108C21.4839 61.0939 21.3924 61.1604 21.2844 61.1604H8.06995C7.96191 61.1604 7.87049 61.0939 7.87049 61.0108V57.1047C7.87049 57.0299 7.96191 56.9634 8.06995 56.9634ZM35.2884 7.03939H66.654C67.1776 7.03939 67.6097 7.47156 67.6097 7.99515V18.226C67.6097 18.7495 67.1776 19.1817 66.654 19.1817H35.2884C34.7648 19.1817 34.3326 18.7495 34.3326 18.226V7.99515C34.3243 7.47156 34.7565 7.03939 35.2884 7.03939ZM80.9488 87.2818C80.0762 85.5282 78.9708 84.0405 77.6743 82.6443C80.1011 83.5834 82.5861 84.5142 84.4228 85.6695C87.7638 87.7638 88.0132 90.2987 88.2874 93.9389H71.7237C71.7237 93.9139 71.7237 93.8807 71.7237 93.8558L71.4162 91.2544L72.6046 92.285L78.4223 87.2236L80.9488 87.2818ZM21.675 83.1762L23.7777 89.3595L24.8332 85.6861L24.3179 85.1209C24.0852 84.7802 24.0353 84.481 24.16 84.2234C24.4426 83.6665 25.0243 83.7746 25.5645 83.7746C26.1297 83.7746 26.8361 83.6665 27.0106 84.3813C27.0688 84.6223 26.994 84.8716 26.8278 85.1293L26.3125 85.6944L27.368 89.3678L29.2712 83.1845C29.5455 83.4338 29.9361 83.6416 30.3849 83.8244C30.227 84.1569 30.0857 84.4976 29.961 84.8633C29.6369 85.8024 29.4291 86.8413 29.3377 87.9965H29.346C29.346 88.0215 29.346 88.0547 29.3377 88.0797L28.8806 93.9472H13.6632C12.749 93.8807 12.2836 93.407 12.2088 92.5925L12.5246 89.3512C12.6161 88.196 12.9402 87.2901 13.4638 86.592C13.8128 86.1349 14.245 85.7941 14.7187 85.5282C16.2313 84.6555 20.3037 84.4145 21.675 83.1762ZM20.6444 74.4081C20.4367 74.4247 20.2871 74.4746 20.1707 74.5411C20.1042 74.5826 20.0627 74.6408 20.0294 74.7073C19.9962 74.7821 19.9796 74.8818 19.9796 74.9899C19.9879 75.3306 20.1707 75.7877 20.5281 76.3113L20.5364 76.3196L21.7083 78.1896C22.1737 78.9376 22.6723 79.6939 23.2707 80.2507C23.8442 80.7743 24.5506 81.1317 25.4731 81.14C26.4787 81.14 27.2101 80.7743 27.8085 80.2175C28.4318 79.6357 28.9305 78.8212 29.4208 78.0151L30.7423 75.8376C31.0082 75.2309 31.0913 74.8652 31.0082 74.6907C30.9584 74.5826 30.734 74.5577 30.3766 74.5826C30.1439 74.6325 29.9112 74.5909 29.6535 74.458L30.3101 72.48C27.8916 72.4467 26.2294 72.0312 24.2763 70.7762C23.6364 70.369 23.4369 69.8952 22.797 69.9368C22.3066 70.0282 21.8994 70.2526 21.5753 70.6017C21.2595 70.9341 21.0268 71.3912 20.8772 71.9813L21.2678 74.3582C21.06 74.4829 20.8522 74.4912 20.6444 74.4081ZM31.1246 73.818C31.4072 73.9011 31.6149 74.0674 31.7479 74.3167C31.9474 74.7239 31.8726 75.3223 31.4986 76.17C31.4903 76.1867 31.4819 76.2033 31.4736 76.2199L30.1356 78.4223C29.6203 79.2783 29.0884 80.1344 28.382 80.7992C27.6423 81.4891 26.7364 81.9462 25.4897 81.9462C24.3262 81.9462 23.4536 81.4974 22.7388 80.8408C22.049 80.2092 21.5254 79.403 21.0351 78.6134L19.8632 76.7435C19.4227 76.0869 19.1983 75.4885 19.1817 74.9982C19.1734 74.7572 19.215 74.5411 19.3064 74.3499C19.3978 74.1505 19.5474 73.9759 19.7386 73.8513C19.83 73.7848 19.938 73.7349 20.0627 73.6934C19.9879 72.696 19.9629 71.4577 20.0128 70.4105C20.0377 70.1529 20.0876 69.9036 20.1541 69.6459C20.4533 68.5738 21.2096 67.7095 22.1404 67.1194C22.4729 66.9116 22.8302 66.7371 23.2125 66.5958C25.4731 65.7813 28.4651 66.2218 30.0691 67.9588C30.7257 68.6652 31.1329 69.6044 31.216 70.8427L31.1246 73.818ZM42.9511 65.5403C42.6851 65.5735 42.4857 65.64 42.3361 65.7315C42.2363 65.7979 42.1699 65.8811 42.1283 65.9725C42.0784 66.0888 42.0535 66.2301 42.0535 66.388C42.0701 66.895 42.3444 67.5765 42.868 68.3577L42.8763 68.3743L44.6299 71.1668C45.328 72.2805 46.0594 73.4108 46.9653 74.2419C47.8296 75.0314 48.8685 75.5633 50.2481 75.5633C51.7441 75.5633 52.8411 75.0148 53.7221 74.1837C54.6529 73.3111 55.4009 72.106 56.124 70.9009L58.0937 67.6596C58.4926 66.7537 58.609 66.2052 58.4843 65.9558C58.4012 65.7896 58.0604 65.7481 57.4787 65.8063C57.4371 65.8063 57.3872 65.8063 57.3457 65.8063C57.1047 65.8063 56.847 65.7481 56.5561 65.6151L57.4454 62.6564C53.8301 62.6148 51.3618 61.9832 48.4363 60.1132C47.4723 59.4982 47.1897 58.8001 46.2256 58.8666C45.5026 59.0079 44.8875 59.332 44.4055 59.8556C43.9401 60.3543 43.591 61.0358 43.3583 61.9167L43.9816 65.4987C43.6243 65.665 43.2752 65.6816 42.9511 65.5403ZM44.58 78.6134L47.7216 87.8469L49.3007 82.37L48.5277 81.5223C48.1787 81.0153 48.1039 80.5665 48.295 80.1842C48.7106 79.3531 49.5832 79.511 50.3894 79.511C51.2371 79.511 52.2843 79.3531 52.5503 80.4086C52.6417 80.766 52.5253 81.1317 52.276 81.5223L51.5031 82.37L53.0822 87.8469L55.9245 78.6134C57.9773 80.4585 63.2548 80.8325 65.5154 82.0874C66.1304 82.4282 66.6872 82.852 67.1609 83.3923C67.1693 83.3341 67.1859 83.2676 67.2191 83.2177C67.4684 82.7274 67.9837 82.8188 68.4658 82.8188C68.9727 82.8188 69.5961 82.7274 69.754 83.359C69.8038 83.5668 69.7373 83.7912 69.5961 84.0239L69.139 84.5309L70.0781 87.7888L68.873 88.7445L69.2719 93.9721C69.1556 95.1938 68.4658 95.892 67.1028 96H33.4101C32.0471 95.892 31.3573 95.1938 31.2409 93.9721L31.7147 87.8137C31.8476 86.0933 32.3297 84.7303 33.1192 83.6915C33.6345 83.01 34.2827 82.503 34.9975 82.1041C37.2498 80.8325 42.5272 80.4585 44.58 78.6134ZM58.6754 64.651C59.0993 64.7757 59.4151 65.0167 59.6063 65.399C59.9055 66.0057 59.7891 66.895 59.2323 68.1666C59.224 68.1915 59.2073 68.2164 59.199 68.2414L57.1961 71.5325C56.4232 72.8124 55.6336 74.084 54.5781 75.073C53.4728 76.1035 52.1181 76.7934 50.2647 76.785C48.5277 76.785 47.2229 76.1202 46.1508 75.1395C45.1203 74.2003 44.3473 72.9952 43.5993 71.8151L41.8457 69.0226C41.1892 68.0502 40.8567 67.1526 40.8318 66.413C40.8235 66.0556 40.8817 65.7315 41.0146 65.4489C41.1559 65.1497 41.372 64.892 41.6629 64.7009C41.8042 64.6012 41.9704 64.5264 42.1449 64.4599C42.0369 62.9639 42.0036 61.1189 42.0701 59.5647C42.1117 59.1824 42.1782 58.8084 42.2862 58.4261C42.735 56.8221 43.857 55.5339 45.2532 54.6529C45.7436 54.3371 46.2838 54.0795 46.8489 53.88C50.2149 52.6583 54.6862 53.3232 57.0797 55.9162C58.0521 56.9717 58.6671 58.3679 58.8001 60.213L58.6754 64.651ZM64.7674 79.8933L66.3132 79.8518L67.6014 79.8185C66.1054 75.206 66.6041 70.9674 70.2111 67.3604C70.8261 69.3384 72.1974 70.9757 74.5328 72.1808C75.6464 73.0119 76.7269 74.0092 77.774 75.1644C77.9569 74.3998 77.2505 73.4773 76.3944 72.5215C77.184 72.9121 77.9153 73.4607 78.4306 74.5162C79.029 75.7379 79.0207 76.7684 78.8212 78.0982C78.7298 78.7132 78.5802 79.295 78.3641 79.8185H80.5C82.7523 74.9982 81.3228 67.8424 76.7186 64.8089C75.3057 63.8781 74.2917 63.9114 72.6296 63.9114C70.7347 63.9114 69.7623 63.9695 68.1333 65.0499C65.7398 66.6373 64.2604 69.38 63.6454 73.1864C63.5207 75.0896 63.4376 78.3724 64.7674 79.8933ZM80.7411 48.428H93.9555C94.0635 48.428 94.155 48.4945 94.155 48.5776V52.4838C94.155 52.5669 94.0635 52.6334 93.9555 52.6334H80.7411C80.633 52.6334 80.5416 52.5669 80.5416 52.4838V48.5776C80.5416 48.4945 80.633 48.428 80.7411 48.428ZM80.7411 39.8843H93.9555C94.0635 39.8843 94.155 39.9508 94.155 40.0339V43.9401C94.155 44.0232 94.0635 44.0897 93.9555 44.0897H80.7411C80.633 44.0897 80.5416 44.0232 80.5416 43.9401V40.0339C80.5416 39.9508 80.633 39.8843 80.7411 39.8843ZM8.06995 48.428H21.2844C21.3924 48.428 21.4839 48.4945 21.4839 48.5776V52.4838C21.4839 52.5669 21.3924 52.6334 21.2844 52.6334H8.06995C7.96191 52.6334 7.87049 52.5669 7.87049 52.4838V48.5776C7.87049 48.4945 7.96191 48.428 8.06995 48.428ZM8.06995 39.8843H21.2844C21.3924 39.8843 21.4839 39.9508 21.4839 40.0339V43.9401C21.4839 44.0232 21.3924 44.0897 21.2844 44.0897H8.06995C7.96191 44.0897 7.87049 44.0232 7.87049 43.9401V40.0339C7.87049 39.9508 7.96191 39.8843 8.06995 39.8843ZM59.5647 40.7902H66.6207C66.7288 40.7902 66.8202 40.8817 66.8202 40.9897V48.0457C66.8202 48.1538 66.7288 48.2452 66.6207 48.2452H59.5647C59.4567 48.2452 59.3652 48.1538 59.3652 48.0457V40.9897C59.3652 40.8817 59.4567 40.7902 59.5647 40.7902ZM47.439 40.7902H54.495C54.6031 40.7902 54.6945 40.8817 54.6945 40.9897V48.0457C54.6945 48.1538 54.6031 48.2452 54.495 48.2452H47.439C47.331 48.2452 47.2395 48.1538 47.2395 48.0457V40.9897C47.2395 40.8817 47.331 40.7902 47.439 40.7902ZM35.3133 40.7902H42.3693C42.4774 40.7902 42.5688 40.8817 42.5688 40.9897V48.0457C42.5688 48.1538 42.4774 48.2452 42.3693 48.2452H35.3133C35.2053 48.2452 35.1138 48.1538 35.1138 48.0457V40.9897C35.1138 40.8817 35.2053 40.7902 35.3133 40.7902ZM59.5647 27.1021H66.6207C66.7288 27.1021 66.8202 27.1935 66.8202 27.3015V34.3575C66.8202 34.4656 66.7288 34.557 66.6207 34.557H59.5647C59.4567 34.557 59.3652 34.4656 59.3652 34.3575V27.3015C59.3652 27.1852 59.4567 27.1021 59.5647 27.1021ZM47.439 27.1021H54.495C54.6031 27.1021 54.6945 27.1935 54.6945 27.3015V34.3575C54.6945 34.4656 54.6031 34.557 54.495 34.557H47.439C47.331 34.557 47.2395 34.4656 47.2395 34.3575V27.3015C47.2395 27.1852 47.331 27.1021 47.439 27.1021ZM35.3133 27.1021H42.3693C42.4774 27.1021 42.5688 27.1935 42.5688 27.3015V34.3575C42.5688 34.4656 42.4774 34.557 42.3693 34.557H35.3133C35.2053 34.557 35.1138 34.4656 35.1138 34.3575V27.3015C35.1138 27.1852 35.2053 27.1021 35.3133 27.1021Z'
													fill='#8DC63F'
												/>
											</svg>
										</div>
										<div>
											<h3 className='text-black font-bold mb-1'>
												Enterprise Grade Solutions
											</h3>
											<p className='text-base'>
												Salesmrkt empowers companies to
												curate, high-performing
												services, technology cust-
												omized for their brand and their
												target market.
											</p>
										</div>
									</div>
									<div className='flex border rounded-lg p-2 md:border-none md:p-0 items-center gap-6 justify-center'>
										<div>
											<svg
												width='30'
												height='30'
												viewBox='0 0 102 102'
												fill='none'
												xmlns='http://www.w3.org/2000/svg'>
												<path
													d='M16.6117 44.2332C16.1859 45.0857 15.4521 45.7342 14.5666 46.0405C13.6811 46.3468 12.7139 46.2868 11.871 45.8732C11.0281 45.4596 10.3761 44.7251 10.0537 43.8261C9.73142 42.9272 9.76431 41.9348 10.1454 41.0603C10.8362 39.5482 11.6094 38.0772 12.4613 36.654C13.3288 35.2331 14.2709 33.8616 15.2836 32.5454L15.3334 32.4774C16.3297 31.1936 17.3909 29.9642 18.5126 28.7941C19.6579 27.5935 20.8661 26.4577 22.1317 25.3916C22.8681 24.7862 23.8073 24.502 24.7465 24.6005C25.212 24.6484 25.6637 24.7904 26.0754 25.0182C26.4872 25.2459 26.8508 25.555 27.1454 25.9275C27.7361 26.6821 28.0134 27.6446 27.9174 28.607C27.8706 29.084 27.732 29.5469 27.5098 29.9688C27.2875 30.3907 26.986 30.7634 26.6225 31.0653C25.5538 31.9538 24.534 32.9023 23.5678 33.9064C20.704 36.9276 18.353 40.4179 16.6117 44.2332ZM7.40614 81.2274L7.61366 81.0658C9.74697 79.7643 12.976 80.1046 15.0844 78.5989C15.238 78.3541 15.3686 78.0949 15.4745 77.8249C15.6737 77.3655 15.848 76.8636 15.9643 76.5234C15.4952 75.9316 15.068 75.3062 14.6859 74.652L13.391 72.5424C12.9761 71.9774 12.7206 71.3065 12.6522 70.6029C12.6396 70.3636 12.6823 70.1246 12.7768 69.9054C12.8707 69.6898 13.0235 69.5067 13.2167 69.378C13.3157 69.3124 13.4215 69.2582 13.5321 69.2164C13.4459 67.9538 13.4265 66.6873 13.474 65.4226C13.5453 64.6551 13.7961 63.9166 14.205 63.2695C14.6139 62.6225 15.1689 62.0859 15.8231 61.7053C16.3884 61.3326 17.0036 61.0461 17.6493 60.8546C18.0644 60.7355 17.3007 59.3915 17.724 59.349C19.7826 59.1278 23.1112 61.0503 24.539 62.641C25.3247 63.5391 25.7746 64.6933 25.809 65.8989L25.7343 69.3015C25.9018 69.3459 26.054 69.437 26.1741 69.5646C26.2943 69.6922 26.3776 69.8514 26.4149 70.0245C26.4843 70.6519 26.3594 71.2857 26.058 71.8364L24.5888 74.3287C24.0854 75.2492 23.4781 76.1058 22.7792 76.8807C22.838 76.9803 22.9017 77.0769 22.9701 77.1699C23.2524 77.6244 23.5747 78.0515 23.933 78.4458C25.5932 79.6793 29.7436 79.977 31.3539 80.8787H31.412L31.6112 81.0403C34.1619 77.9417 35.4908 73.9784 35.3372 69.9277C35.1836 65.877 33.5587 62.0313 30.7812 59.1449L30.723 59.2384C27.8218 56.3093 23.9324 54.636 19.8603 54.5649C15.7882 54.4939 11.8454 56.0305 8.84859 58.8567C5.85175 61.6829 4.03046 65.582 3.76194 69.7465C3.49342 73.9109 4.79823 78.0217 7.40614 81.2274ZM19.517 50.7406C22.0781 50.7368 24.6147 51.252 26.9809 52.2563C29.3471 53.2607 31.4962 54.7345 33.3046 56.5929L33.4125 56.712C37.022 60.4693 39.0361 65.5362 39.0159 70.8086C38.9957 76.081 36.9428 81.1316 33.3046 84.8596L33.1884 84.9702C30.9069 87.2689 28.1085 88.957 25.0399 89.8855C21.9714 90.8141 18.727 90.9545 15.593 90.2945C12.459 89.6345 9.53158 88.1943 7.06905 86.1009C4.60652 84.0075 2.68451 81.3253 1.47255 78.2909C0.260587 75.2565 -0.204082 71.963 0.119525 68.7011C0.443132 65.4391 1.54507 62.3089 3.32815 59.5865C5.11122 56.8641 7.52065 54.6331 10.3439 53.0904C13.1671 51.5478 16.3175 50.7407 19.517 50.7406ZM71.0317 81.7548C72.6171 80.3257 76.0121 79.9685 78.0956 78.7095C79.9218 77.5867 79.6064 76.4553 79.5981 74.6009H76.7011C69.1806 74.6009 74.1362 75.2049 75.1572 66.8346C76.6845 55.0108 88.3056 55.0023 90.0239 66.8346C91.1196 74.8902 95.8344 74.6009 88.4716 74.6009H85.5082C85.5082 76.651 85.1845 77.6973 87.2597 78.8541C88.8036 79.7048 92.3149 80.2577 93.9999 81.6868C96.8235 78.6307 98.3812 74.572 98.3456 70.3636C98.31 66.1552 96.6839 62.1248 93.809 59.1193L93.7094 59.0343C90.7527 56.0098 86.7512 54.3027 82.5736 54.2836C78.3961 54.2645 74.3798 55.9349 71.3969 58.9322L71.3056 59.0343C68.3793 62.0388 66.7146 66.0962 66.6665 70.3409C66.6184 74.5856 68.1908 78.6815 71.0483 81.7548H71.0317ZM82.5033 50.5364C85.0657 50.533 87.6034 51.0482 89.9709 52.0525C92.3384 53.0568 94.489 54.5304 96.2993 56.3888L96.3989 56.5079C100.011 60.2629 102.028 65.3296 102.01 70.6027C101.991 75.8758 99.9384 80.9274 96.2993 84.6555L96.183 84.7661C92.5187 88.4691 87.5735 90.5359 82.4271 90.5152C77.2808 90.4945 72.3516 88.3879 68.7157 84.6555L68.6078 84.5449C64.9938 80.7884 62.9767 75.7192 62.9969 70.444C63.0171 65.1689 65.073 60.1161 68.7157 56.3888L68.8237 56.2782C72.4689 52.5946 77.3839 50.5316 82.5033 50.5364ZM40.4516 30.4869L40.6591 30.3167C42.8007 29.0238 46.0214 29.364 48.1298 27.8584C48.2768 27.6097 48.4072 27.3511 48.5199 27.0843C48.7108 26.625 48.8935 26.1231 49.0014 25.7828C48.5351 25.1889 48.108 24.5637 47.7231 23.9114L46.4281 21.8019C46.0058 21.2421 45.7416 20.5741 45.6645 19.8709C45.6528 19.6344 45.6955 19.3984 45.789 19.1819C45.886 18.9657 46.0416 18.7827 46.2372 18.6545C46.3343 18.5856 46.4406 18.5311 46.5526 18.4929C46.4622 17.2305 46.4428 15.9637 46.4945 14.699C46.5227 14.4113 46.5755 14.1267 46.6523 13.8484C47.0157 12.6524 47.7957 11.6351 48.8437 10.9903C49.4119 10.6175 50.0298 10.3309 50.6781 10.1396C51.0849 10.0205 50.3295 8.67653 50.7528 8.62549C52.8031 8.41283 56.1318 10.3268 57.5678 11.926C58.345 12.826 58.7938 13.9743 58.8378 15.1754L58.7548 18.5779C58.9223 18.6224 59.0745 18.7135 59.1947 18.8411C59.3148 18.9687 59.3981 19.1279 59.4355 19.301C59.5048 19.9284 59.3799 20.5622 59.0785 21.1128C59.0806 21.1269 59.0806 21.1413 59.0785 21.1554L57.601 23.6477C57.1005 24.5701 56.4928 25.4269 55.7914 26.1997L55.9823 26.4889C56.2647 26.9407 56.587 27.365 56.9452 27.7563V27.7989C58.6054 29.0323 62.7558 29.33 64.3661 30.2317H64.4242L64.6235 30.3933C67.1705 27.2931 68.4971 23.3306 68.3436 19.281C68.19 15.2314 66.5675 11.3862 63.7934 8.49789L63.7768 8.5064C60.8799 5.55646 56.9843 3.86515 52.9011 3.78455C48.8179 3.70396 44.8617 5.2403 41.8561 8.07374C38.8505 10.9072 37.027 14.8194 36.7654 18.9959C36.5038 23.1724 37.8241 27.2914 40.4516 30.4954V30.4869ZM52.5624 2.0112e-05C55.1235 -0.00370987 57.6601 0.511419 60.0263 1.51579C62.3925 2.52015 64.5416 3.99394 66.35 5.85241L66.4579 5.9715C70.0715 9.72658 72.0884 14.7943 72.0681 20.0681C72.0479 25.3419 69.9922 30.3932 66.35 34.1191L66.2421 34.2297C63.9609 36.5282 61.1628 38.2161 58.0947 39.1447C55.0265 40.0733 51.7825 40.214 48.6487 39.5544C45.515 38.8948 42.5878 37.4551 40.1252 35.3624C37.6626 33.2697 35.7403 30.5881 34.5279 27.5543C33.3154 24.5205 32.85 21.2275 33.1727 17.9658C33.4955 14.7041 34.5964 11.5739 36.3784 8.85123C38.1604 6.12853 40.5688 3.897 43.3912 2.35341C46.2136 0.80982 49.3632 0.00159963 52.5624 2.0112e-05ZM76.6347 31.7203C76.095 31.2523 75.7024 30.6313 75.5061 29.9353C75.3099 29.2393 75.3188 28.4994 75.5316 27.8086C75.7445 27.1177 76.1519 26.5068 76.7027 26.0525C77.2534 25.5983 77.9228 25.321 78.6269 25.2555C79.571 25.1768 80.5074 25.4824 81.2333 26.1061L82.4951 27.2204L83.7319 28.4283C84.5619 29.279 85.392 30.1296 86.1059 30.9802C86.8198 31.8309 87.5419 32.7326 88.1977 33.6342C88.8534 34.5359 89.5175 35.5226 90.1235 36.5094C90.7294 37.4961 91.3022 38.4999 91.7836 39.5036V39.6057C92.0882 40.2486 92.2027 40.9686 92.1132 41.6773C92.0237 42.386 91.7341 43.0524 91.2799 43.5946C90.8257 44.1369 90.2268 44.5313 89.5568 44.7294C88.8868 44.9274 88.175 44.9205 87.5087 44.7095C86.6469 44.4153 85.9298 43.7903 85.5082 42.9657C85.0766 42.1151 84.5951 41.2645 84.0888 40.4649C83.5825 39.6653 83.0346 38.8316 82.4784 38.0746C81.9223 37.3175 81.2748 36.5264 80.6274 35.7268C79.9799 34.9272 79.3657 34.2977 78.7182 33.6427C78.0707 32.9877 77.3486 32.3242 76.6181 31.6863L76.6347 31.7203ZM63.1376 92.7195C63.5815 92.5661 64.0507 92.5044 64.5181 92.538C64.9854 92.5716 65.4416 92.6998 65.8603 92.9152H65.9267C66.7481 93.3538 67.3725 94.1003 67.6699 94.9992C67.9617 95.9187 67.8873 96.919 67.4629 97.7825C67.0384 98.6459 66.2984 99.3027 65.4037 99.6097C64.2665 100.001 63.121 100.341 61.9589 100.639C60.7968 100.937 59.6679 101.166 58.4809 101.362C57.2939 101.558 56.1069 101.711 54.9364 101.804C53.766 101.898 52.5375 101.957 51.3505 101.957C50.1635 101.957 48.9267 101.906 47.7148 101.804C46.5028 101.702 45.3075 101.549 44.0956 101.345C42.8837 101.141 41.6718 100.877 40.518 100.579C39.3642 100.282 38.1689 99.9159 37.0399 99.5246C36.5937 99.3666 36.1822 99.1199 35.829 98.7988C35.4757 98.4777 35.1877 98.0884 34.9814 97.6532C34.7721 97.2206 34.6489 96.7495 34.619 96.2676C34.589 95.7857 34.653 95.3025 34.807 94.8461C35.1174 93.9245 35.7709 93.1662 36.6249 92.7365C37.0471 92.5221 37.5067 92.3959 37.977 92.3652C38.4473 92.3345 38.9188 92.4 39.3642 92.5579C40.3022 92.8811 41.2733 93.1789 42.2611 93.4085C43.224 93.6552 44.1952 93.8679 45.1581 94.0295C46.121 94.1911 47.1254 94.3187 48.1547 94.4038C49.184 94.4889 50.1718 94.5314 51.226 94.5314C52.2802 94.5314 53.268 94.4889 54.2475 94.4038C55.227 94.3187 56.2563 94.1996 57.2026 94.038H57.2607C58.2236 93.8764 59.1947 93.6722 60.1576 93.4256C61.1205 93.1789 62.0834 92.8982 63.0131 92.5749L63.1376 92.7195Z'
													fill='#8DC63F'
												/>
											</svg>
										</div>
										<div>
											<h3 className='text-black font-bold mb-1'>
												Human Centric Approach
											</h3>
											<p className='text-base'>
												Salesmrkt leads the way with an
												integrated enterprise-level
												team, incorporating a
												personalized touch to streamline
												high-end & sophisticated sales
												transactions.
											</p>
										</div>
									</div>
								</div>
							</div>
						</div>

						<div className='w-[90%] flex flex-col items-center gap-6 justify-center md:mt-16'>
							<div
								id='Vision'
								className='w-[100%] flex flex-col items-center  justify-center mt-16 -mb-6 '>
								<h1 className='text-black text-xl md:text-2xl lg:text-4xl md:mb-2 font-bold'>
									All-in-One B2B Marketplace
								</h1>
								<h1 className='text-black text-base md:text-xl  font-medium'>
									Connecting Buyers to Sellers
								</h1>
							</div>

							<div className='w-full relative hidden md:flex'>
								<img
									src={ThirdSectionImage}
									alt=''
								/>
							</div>
							<div className='w-full relative flex md:hidden'>
								<img
									src={ThirdSectionImageMobile}
									alt=''
								/>
							</div>
						</div>
						<div
							id='SupplyChain'
							className='w-[90%] flex flex-col items-center gap-6 justify-center md:mt-16'>
							<div className='w-[100%] flex flex-col items-center  justify-center mt-16 -mb-10'>
								<h1 className='text-black text-xl md:text-2xl text-center  md:w-full  lg:text-4xl mb-4 font-bold'>
									Building the Service Supply Chain{' '}
									<br className='flex md:hidden'></br> of the
									Future
								</h1>
								<h1 className='text-black  md:text-start text-base hidden md:flex md:text-xl  mb-6 font-medium'>
									Integrating Multi-Vendor Fulfillment
									Solutions with Just a Click
								</h1>
							</div>

							<div className='w-full relative hidden md:flex'>
								<img
									src={SupplyChain}
									alt='SupplyChain'
									className=''
								/>
							</div>
							<div className='w-full relative  items-center flex md:hidden'>
								<img
									src={SupplyChainMobile}
									alt='SupplyChain'
									className=''
								/>
							</div>
						</div>

						<div
							id='ConsumerModel'
							className='w-[100%] p-4 md:p-0 flex flex-col items-center mt-10 md:-mb-32  justify-center md:mt-24'>
							<h1 className='text-black text-center text-xl lg:text-4xl mb-2 md:mt-16 font-bold'>
								Next Generation Marketplace
							</h1>
							<h1 className='text-black text-center text-sm md:text-xl  font-medium'>
								Building upon the Proven Consumer (B2C) Model
							</h1>
						</div>
						<div className='w-[90%] flex items-start gap-6 mt-6 justify-start '>
							<img
								src={NextGen_MarketPlace}
								alt='NextGen_MarketPlace'
								className='hidden md:flex'
							/>
							<img
								src={NextGen_MarketPlaceMobile}
								alt='NextGen_MarketPlace'
								className='flex md:hidden'
							/>
						</div>
						<div
							id='Advantage'
							className='w-[100%] flex flex-col items-center  justify-center md:mt-24 md:-mb-24'>
							<h1 className='text-black text-xl lg:text-4xl mb-2 mt-16 font-bold'>
								First-Mover Advantage
							</h1>
							<h1 className='text-black text-sm md:text-xl md:mb-6 font-medium'>
								US Business Spend on B2B Services
							</h1>
						</div>
						<div className='w-[90%] flex items-center gap-6 justify-center  '>
							<div className='flex flex-col items-center gap-10 justify-center'>
								<img
									src={FirstMoverAdvantage}
									alt=''
								/>

								<a
									href='https://www.forrester.com/press-newsroom/forrester-us-b2b-e-commerce-will-reach-an-estimated-3-trillion-by-2027/#:~:text=Trillion%20By%202027-,Forrester%3A%20US%20B2B%20E%2DCommerce%20Will%20Reach%20An,Estimated%20%243%20Trillion%20By%202027&text=While%20US%20B2B%20e%2Dcommerce,and%20%243%20trillion%20by%202027'
									target='_blank'
									rel='noopener noreferrer'>
									<div className='flex items-center gap-6 justify-center'>
										<p className='underline text-xs md:text-base'>
											Forrester US B2B E-Commerce Market -
											2022{' '}
										</p>
									</div>
								</a>
							</div>
						</div>
						<div
							id='Results'
							className='w-[100%] flex flex-col items-center  justify-center md:mt-32'>
							<h1 className='text-black text-xl lg:text-4xl mb-2 mt-16 font-bold'>
								Proven Market Demand
							</h1>
							<h1 className='text-black text-xs md:text-xl mb-6 font-medium'>
								Established Product Fit & Momentum for the
								Future
							</h1>
						</div>

						<div className='w-[90%] h-full flex items-center -mt-3 gap-6 justify-center '>
							<img
								src={ProvenDemand}
								alt='ProvenDemand'
								className='hidden md:flex'
							/>
							<img
								src={ProvenDemandMobile}
								alt='ProvenDemand'
								className='flex md:hidden'
							/>
						</div>

						<div className='w-[90%] hidden lg:flex h-full  items-center gap-6 justify-center mt-24'>
							<ImageSlider />
						</div>
						<div className='w-[100%] hidden lg:flex flex-col items-center  justify-center '>
							<h1 className='text-black text-xl mb-6 mt-4 font-medium'>
								Providing small & medium businesses a strategic
								advantage to compete with large enterprises
							</h1>
						</div>

						<div className='w-[100%] flex flex-col items-center gap-6 justify-center md:mt-16'>
							<div
								id='Team'
								onMouseEnter={handleMouseEnterTeamVideo}
								onMouseLeave={handleMouseLeaveTeamVideo}
								className='w-[90%] h-full  mt-16 flex flex-col items-start justify-between gap-6'>
								<div
									ref={videoRefIntersector}
									className='flex flex-col items-start justify-start'>
									<h2 className='text-black font-bold text-3xl md:text-5xl '>
										Over 80+
									</h2>
									<p className='md:ml-2'>Team Members</p>
								</div>
								<div className='flex flex-col items-start justify-center'>
									<div className='grid grid-cols-2 md:grid-cols-4 xl:grid-cols-6 items-center justify-center gap-2 w-full'>
										<div className='flex flex-col items-start justify-start  '>
											<img
												src={Joe}
												alt=''
												className=' w-full  '
											/>
											<div className='flex flex-col items-start justify-start'>
												<h3 className='text-black text-base font-bold'>
													Joseph Greco
												</h3>
												<p className='text-sm'>
													Founder & CEO
												</p>
											</div>
										</div>
										<div className='flex flex-col items-start justify-start '>
											<img
												src={Pria}
												alt=''
												className=' w-full '
											/>
											<div className='flex flex-col items-start justify-start'>
												<h3 className='text-black  md:text-base font-bold'>
													Pria Vijayaratnam
												</h3>
												<p className='text-sm'>CRO</p>
											</div>
										</div>
										<div className='flex flex-col items-start justify-start '>
											<img
												src={Danny}
												alt=''
												className=' w-full '
											/>
											<div className='flex flex-col items-start justify-start'>
												<h3 className='text-black text-base font-bold'>
													Danny Gibson
												</h3>
												<p className='text-sm'>
													Director of Marketing
												</p>
											</div>
										</div>
										<div className='flex flex-col items-start justify-start '>
											<img
												src={Amrit}
												alt=''
												className=' w-full '
											/>
											<div className='flex flex-col items-start justify-start'>
												<h3 className='text-black text-base font-bold'>
													Amrit Seth
												</h3>
												<p className='text-sm'>
													Head of Sales Operations
												</p>
											</div>
										</div>
										<div className='flex flex-col items-start justify-start '>
											<img
												src={Nee}
												alt=''
												className=' w-full '
											/>
											<div className='flex flex-col items-start justify-start'>
												<h3 className='text-black text-base font-bold'>
													Nii Harper
												</h3>
												<p className='text-sm'>
													Director Client Services
												</p>
											</div>
										</div>
										<div className='flex flex-col items-start justify-start '>
											<img
												src={Madiha}
												alt=''
												className=' w-full '
											/>
											<div className='flex flex-col items-start justify-start'>
												<h3 className='text-black text-base font-bold'>
													Madiha Nayyar
												</h3>
												<p className='text-sm'>
													Director Client Services
												</p>
											</div>
										</div>
										<div className='flex flex-col items-start justify-start '>
											<img
												src={Karim}
												alt=''
												className=' w-full '
											/>
											<div className='flex flex-col items-start justify-start'>
												<h3 className='text-black md:text-base font-bold'>
													Karim Mosalamy
												</h3>
												<p className='text-sm'>
													Head of Sales Innovation
												</p>
											</div>
										</div>
										<div className='flex flex-col items-start justify-start '>
											<img
												src={Kris}
												alt=''
												className=' w-full '
											/>
											<div className='flex flex-col items-start justify-start'>
												<h3 className='text-black text-base font-bold'>
													Kris Endique
												</h3>
												<p className='text-sm'>
													Head of Partnerships
												</p>
											</div>
										</div>
										<div className='flex flex-col items-start justify-start '>
											<img
												src={Jose}
												alt=''
												className=' w-full '
											/>
											<div className='flex flex-col items-start justify-start'>
												<h3 className='text-black text-base font-bold'>
													Jose Ruiz
												</h3>
												<p className='text-sm'>
													Fractional CFO
												</p>
											</div>
										</div>
										<div className='flex flex-col items-start justify-start '>
											<img
												src={John}
												alt=''
												className=' w-full '
											/>
											<div className='flex flex-col items-start justify-start'>
												<h3 className='text-black text-base font-bold'>
													John Cuellar
												</h3>
												<p className='text-sm'>
													Fractional CTO
												</p>
											</div>
										</div>
										<div className='flex flex-col items-start justify-start '>
											<img
												src={Tyler}
												alt=''
												className=' w-full '
											/>
											<div className='flex flex-col items-start justify-start'>
												<h3 className='text-black text-base font-bold'>
													Tyler Gillespie
												</h3>
												<p className='text-sm'>
													Product Advisor
												</p>
											</div>
										</div>
										<div className='flex flex-col items-start justify-start '>
											<img
												src={Mury}
												alt=''
												className=' w-full '
											/>
											<div className='flex flex-col items-start justify-start'>
												<h3 className='text-black text-base font-bold'>
													Murry Warner
												</h3>
												<p className='text-sm'>
													Partnership Advisor
												</p>
											</div>
										</div>
									</div>

									<h2 className='text-black text-start md:text-center font-semibold  w-full text-lg md:text-2xl  mt-10 '>
										Lead by a team of Sales, Marketing &
										Tech Experts aligned by vision on a path
										for success.
									</h2>

									<div className='hidden md:flex items-center justify-center mt-10  '>
										<video
											className='rounded-xl w-full   lg:w-[70%] shadow-lg'
											ref={videoRefTeam}
											muted
											autoPlay
											src={TeamImage}
										/>
									</div>
									<div className='flex items-center justify-center mt-10  '>
										<video
											className='rounded-xl w-full flex md:hidden   lg:w-[65%] shadow-lg'
											muted
											autoPlay
											loop
											playsInline
											disablePictureInPicture
											preload={'auto'}
											src={TeamImage}
										/>
									</div>
								</div>
							</div>
						</div>
					</div>
					{true && (
						<div className='w-[450px]  bg-white hidden    sticky  rounded shadow-lg outline outline-black/10 outline-1 z-30 top-[100px] mt-16  lg:flex flex-col items-center justify-around gap-6 p-4 '>
							<div>
								<h2 className='text-center text-black  '>
									<b className='text-lime-500'>Highlights</b>
								</h2>
							</div>
							<div className='grid grid-cols-2 pl-4 pr-4 w-full gap-2 items-center justify-center'>
								<h4 className='text-center text-3xl  hover:bg-lime-500 hover:text-white transition-all duration-200 ease-in border rounded p-2 flex cursor-default flex-col'>
									$2.4M{' '}
									<span className='text-xs'>
										Revenue to Date
									</span>
								</h4>

								<h4 className=' text-center text-3xl flex flex-col border rounded p-2 hover:bg-lime-500 hover:text-white transition-all duration-200 ease-in cursor-default'>
									≈4X{' '}
									<span className='text-xs'>
										{' '}
										Growth in 3 years
									</span>
								</h4>
								<h4 className=' text-center text-3xl flex flex-col border rounded p-2 hover:bg-lime-500 hover:text-white transition-all duration-200 ease-in cursor-default'>
									152{' '}
									<span className='text-xs'>
										Clients and Growing
									</span>
								</h4>
								<h4 className=' text-center text-3xl flex flex-col border rounded p-2 hover:bg-lime-500 hover:text-white transition-all duration-200 ease-in cursor-default'>
									65+{' '}
									<span className='text-xs'>
										Team Members
									</span>
								</h4>
							</div>
							<div className='w-full flex flex-col pl-4 pr-4'>
								<a
									href='https://wefunder.com/salesmrkt'
									target='_blank'
									rel='noopener noreferrer'>
									<p className='p-2   w-full cursor-pointer  rounded   text-center text-black   font-semibold  border border-lime-500   overflow-hidden group  relative hover:bg-gradient-to-r hover:from-lime-500 hover:to-lime-400  hover:ring-2 hover:ring-offset-2 hover:ring-lime-400 transition-all ease-out duration-300'>
										Invest In Salesmrkt
									</p>
								</a>

								<a
									href='https://calendly.com/salesbox-meet/investor-relations'
									target='_blank'
									rel='noopener noreferrer'>
									<p className='p-2 flex items-center justify-center cursor-pointer gap-2  mt-3 w-full  rounded   text-center text-black   font-semibold  border border-lime-500    overflow-hidden group  relative hover:bg-gradient-to-r hover:from-lime-500 hover:to-lime-400  hover:ring-2 hover:ring-offset-2 hover:ring-lime-400 transition-all ease-out duration-300'>
										Schedule a Meeting
									</p>
								</a>
								<a
									href='https://wefunder.com/salesmrkt'
									target='_blank'
									rel='noopener noreferrer'>
									<div className='w-full items-center hover:scale-105 transition-all duration-150 ease-in mt-1 justify-center flex'>
										<svg
											className=''
											width='150'
											height='63'
											viewBox='0 0 251 63'
											fill='none'
											xmlns='http://www.w3.org/2000/svg'>
											<path
												d='M71.7762 27V12.363H80.0502V13.917H73.6872V18.852H78.8532V20.406H73.6872V27H71.7762ZM82.3582 27V15.492H84.2692V27H82.3582ZM83.3452 13.623C82.6102 13.623 82.0432 13.056 82.0432 12.321C82.0432 11.586 82.6102 11.019 83.3452 11.019C84.0382 11.019 84.6052 11.586 84.6052 12.321C84.6052 13.056 84.0382 13.623 83.3452 13.623ZM95.9472 27V20.49C95.9472 18.138 94.6662 16.941 92.7342 16.941C90.7812 16.941 89.4372 18.159 89.4372 20.637V27H87.5262V15.492H89.4372V17.13C90.1932 15.933 91.5792 15.282 93.1332 15.282C95.8002 15.282 97.8372 16.92 97.8372 20.217V27H95.9472ZM100.245 21.204C100.245 17.613 102.618 15.303 105.726 15.303C107.532 15.303 109.191 16.227 109.989 17.55V11.46H111.921V27H109.989V24.837C109.296 26.118 107.805 27.189 105.705 27.189C102.618 27.189 100.245 24.774 100.245 21.204ZM109.989 21.225C109.989 18.558 108.183 16.962 106.083 16.962C103.983 16.962 102.198 18.495 102.198 21.204C102.198 23.913 103.983 25.509 106.083 25.509C108.183 25.509 109.989 23.934 109.989 21.225ZM130.955 15.492V27H129.044V25.299C128.309 26.496 126.902 27.168 125.369 27.168C122.723 27.168 120.644 25.53 120.644 22.233V15.492H122.534V21.981C122.534 24.312 123.815 25.509 125.747 25.509C127.721 25.509 129.044 24.291 129.044 21.813V15.492H130.955ZM142.455 23.871C142.455 25.761 140.796 27.189 138.255 27.189C135.567 27.189 133.677 25.719 133.551 23.619H135.525C135.63 24.732 136.617 25.572 138.234 25.572C139.746 25.572 140.586 24.816 140.586 23.871C140.586 21.309 133.782 22.8 133.782 18.516C133.782 16.752 135.441 15.303 138.003 15.303C140.544 15.303 142.224 16.668 142.35 18.915H140.439C140.355 17.76 139.473 16.92 137.94 16.92C136.533 16.92 135.693 17.592 135.693 18.516C135.693 21.246 142.371 19.755 142.455 23.871ZM161.672 21.225C161.672 24.879 159.047 27.189 155.771 27.189C152.516 27.189 150.038 24.879 150.038 21.225C150.038 17.592 152.6 15.303 155.855 15.303C159.131 15.303 161.672 17.592 161.672 21.225ZM151.991 21.225C151.991 24.144 153.776 25.509 155.771 25.509C157.766 25.509 159.719 24.144 159.719 21.225C159.719 18.327 157.808 16.962 155.834 16.962C153.818 16.962 151.991 18.327 151.991 21.225ZM172.605 27V20.49C172.605 18.138 171.324 16.941 169.392 16.941C167.439 16.941 166.095 18.159 166.095 20.637V27H164.184V15.492H166.095V17.13C166.851 15.933 168.237 15.282 169.791 15.282C172.458 15.282 174.495 16.92 174.495 20.217V27H172.605Z'
												fill='black'
											/>
											<path
												d='M66 59.5981H85.7413V54.5927H71.436V48.7104H83.8817V43.705H71.436V38.0054H85.5625V33H66V59.5981ZM91.2159 59.5981H96.6877V49.1853H109.276V44.0703H96.6877V38.115H110.921V33H91.2159V59.5981ZM126.708 60C133.682 60 138.081 56.0542 138.081 48.0161V33H132.609V48.2719C132.609 52.6197 130.392 54.8485 126.78 54.8485C123.168 54.8485 120.986 52.5101 120.986 48.0527V33H115.479V48.2354C115.479 56.0176 119.77 60 126.708 60ZM144.302 59.5981H149.702V42.28L162.649 59.5981H167.333V33H161.898V49.7699L149.344 33H144.302V59.5981ZM173.988 59.5981H184.038C192.228 59.5981 197.879 53.7888 197.879 46.299V46.226C197.879 38.7361 192.228 33 184.038 33H173.988V59.5981ZM184.038 38.0784C188.865 38.0784 192.121 41.4762 192.121 46.299V46.3721C192.121 51.1949 188.865 54.5195 184.038 54.5195H179.459V38.0784H184.038ZM203.36 59.5981H223.102V54.5927H208.796V48.7104H221.242V43.705H208.796V38.0054H222.923V33H203.36V59.5981ZM234.048 45.9702V38.0784H239.949C242.845 38.0784 244.634 39.4302 244.634 41.9878V42.0608C244.634 44.3991 242.917 45.9702 240.057 45.9702H234.048ZM228.577 59.5981H234.048V50.9391H238.804L244.562 59.5981H251L244.49 49.9891C247.852 48.7834 250.177 46.0797 250.177 41.7686V41.6954C250.177 39.2476 249.427 37.165 247.995 35.7037C246.278 33.9499 243.704 33 240.413 33H228.577V59.5981Z'
												fill='#3077B8'
											/>
											<path
												d='M3 45.2287L8.20094 33.9076C8.57346 33.0967 9.72853 33.12 10.0684 33.9452L20.5393 59.3675C20.8935 60.2277 22.1141 60.2052 22.4367 59.3324L34.0839 27.8289C34.3966 26.9828 35.5667 26.9274 35.9574 27.7399L48.6018 54.0392C49.0112 54.8908 50.2523 54.7775 50.5024 53.8659L65 1'
												stroke='#3077B8'
												stroke-width='4.86264'
											/>
										</svg>
									</div>
								</a>
							</div>
							{/* <Countdown initialDays={15} /> */}
						</div>
					)}
				</div>
				<div className='w-[100%] relative flex flex-col p-4 md:p-0 lg:flex-row  items-center gap-6 justify-center mt-16 mb-16 '>
					<img
						src={EndingImage}
						className='w-1/2 hidden md:flex'
					/>
					<div className=' flex flex-col gap-10 items-start justify-center  md:mb-16'>
						<div className='flex flex-col items-start justify-center gap-2'>
							<h1 className='text-lime-500'>Invest Today!</h1>
							<p className='text-black font-medium w-full lg:w-[60%] mt-3 text-lg md:text-3xl'>
								Contact us any time with investment questions.
							</p>
						</div>
						<div className='flex flex-col items-start justify-center gap-6'>
							<div>
								<a
									href='https://salesmrkt.com/'
									target='_blank'
									rel='noopener noreferrer'>
									<div className='flex items-center justify-center gap-3'>
										<svg
											width='36'
											height='36'
											viewBox='0 0 36 36'
											fill='none'
											xmlns='http://www.w3.org/2000/svg'>
											<path
												d='M12.7148 24.4219C16.2518 24.4219 19.7331 24.4219 23.2701 24.4219C23.1937 24.9361 23.1311 25.4364 23.0408 25.9298C22.6725 27.9866 22.1722 30.0018 21.3522 31.9266C20.8241 33.1774 20.2335 34.4004 19.1842 35.3176C18.3503 36.0472 17.6485 36.0403 16.8077 35.3107C16.0572 34.6644 15.5569 33.8306 15.1261 32.955C14.0699 30.8356 13.4584 28.5773 13.0275 26.2564C12.9164 25.6588 12.826 25.0612 12.7148 24.4219Z'
												fill='#8DC63F'
											/>
											<path
												d='M12.7148 11.3025C12.8191 10.6632 12.9164 10.0656 13.0275 9.46103C13.4584 7.14012 14.056 4.87481 15.14 2.76932C15.4944 2.07443 15.9669 1.43514 16.4186 0.795851C17.1899 -0.295113 18.809 -0.239523 19.6289 0.809749C20.3099 1.6853 20.8658 2.63034 21.2966 3.64487C22.3042 6.01441 22.874 8.50209 23.2423 11.0384C23.2562 11.1148 23.2423 11.1982 23.2423 11.3025C19.747 11.3025 16.2587 11.3025 12.7148 11.3025Z'
												fill='#8DC63F'
											/>
											<path
												d='M12.4011 14.5938C16.1535 14.5938 19.8572 14.5938 23.5957 14.5938C23.7555 16.7757 23.7555 18.9368 23.5957 21.1256C19.8641 21.1256 16.1535 21.1256 12.4011 21.1256C12.2413 18.9507 12.2413 16.7896 12.4011 14.5938Z'
												fill='#8DC63F'
											/>
											<path
												d='M9.0526 14.602C9.0526 16.77 9.0526 18.9381 9.0526 21.1409C8.95532 21.1409 8.85803 21.1409 8.7538 21.1409C6.07156 21.1409 3.38236 21.1339 0.700119 21.1478C0.408269 21.1478 0.310984 21.0644 0.255393 20.7795C-0.0850991 18.806 -0.0920446 16.8395 0.276243 14.873C0.310987 14.7062 0.324883 14.5742 0.561143 14.5742C3.37541 14.5812 6.18969 14.5812 8.99701 14.5881C9.01786 14.5812 9.0387 14.5951 9.0526 14.602Z'
												fill='#8DC63F'
											/>
											<path
												d='M26.9531 14.5812C27.0713 14.5812 27.1824 14.5812 27.3006 14.5812C29.962 14.5812 32.6234 14.5881 35.2848 14.5742C35.5836 14.5742 35.7017 14.6507 35.7503 14.9564C36.0839 16.9299 36.0908 18.8964 35.7295 20.8629C35.6947 21.0436 35.653 21.1547 35.4376 21.1478C32.6373 21.1409 29.8369 21.1409 27.0365 21.1409C27.0157 21.1409 26.9948 21.1339 26.9601 21.12C26.9531 18.9659 26.9531 16.7978 26.9531 14.5812Z'
												fill='#8DC63F'
											/>
											<path
												d='M23.543 0.726562C28.8658 2.60969 32.5625 6.1119 34.7653 11.3096C34.5777 11.3166 34.4526 11.3305 34.3345 11.3305C31.8816 11.3305 29.4286 11.3235 26.9687 11.3374C26.6421 11.3374 26.5518 11.2332 26.5032 10.9135C26.0306 7.61284 25.301 4.38164 23.814 1.36585C23.7306 1.19908 23.6472 1.03926 23.5638 0.872488C23.5569 0.865539 23.5569 0.837744 23.543 0.726562Z'
												fill='#8DC63F'
											/>
											<path
												d='M34.7536 24.4362C32.5508 29.62 28.854 33.1292 23.5312 34.922C23.6911 34.5954 23.8648 34.2758 24.0177 33.9422C25.1573 31.5032 25.8105 28.9182 26.276 26.2777C26.3664 25.7565 26.4428 25.2284 26.5123 24.7003C26.5401 24.4918 26.6096 24.3945 26.8319 24.3945C29.3891 24.4015 31.9463 24.4015 34.5034 24.4015C34.566 24.4015 34.6216 24.4154 34.7536 24.4362Z'
												fill='#8DC63F'
											/>
											<path
												d='M1.26172 11.2794C3.4506 6.10945 7.14737 2.60725 12.4771 0.814453C12.3173 1.14105 12.1436 1.46069 11.9907 1.78729C10.8511 4.22632 10.191 6.81128 9.72538 9.45184C9.6281 9.98689 9.55861 10.5289 9.48217 11.064C9.46133 11.2377 9.40574 11.335 9.20422 11.335C6.61231 11.328 4.0204 11.328 1.42849 11.328C1.4007 11.328 1.36595 11.3072 1.26172 11.2794Z'
												fill='#8DC63F'
											/>
											<path
												d='M12.4676 34.915C7.13783 33.1222 3.44106 29.62 1.23828 24.4293C1.41895 24.4154 1.53708 24.4015 1.65521 24.4015C4.12204 24.4015 6.58887 24.4084 9.04876 24.3945C9.3684 24.3945 9.45179 24.4988 9.49348 24.7976C9.95905 28.0983 10.6887 31.3225 12.1757 34.3383C12.273 34.5329 12.3703 34.7205 12.4676 34.915Z'
												fill='#8DC63F'
											/>
										</svg>
										<p className='text-black hover:text-lime-500 transition-all duration-150'>
											www.salesmrkt.com
										</p>
									</div>
								</a>
							</div>
							<div>
								<a href='tel:+1 (206) 452-5000'>
									<div className='flex items-center justify-center gap-3'>
										<svg
											width='34'
											height='34'
											viewBox='0 0 34 34'
											fill='none'
											xmlns='http://www.w3.org/2000/svg'>
											<path
												d='M9.12823 14.0055C10.2423 16.025 11.5262 17.9632 13.1932 19.7306C14.8656 21.5088 16.9453 23.1271 19.6374 24.5096C19.837 24.6072 20.0258 24.6072 20.1957 24.5394C20.452 24.4419 20.7136 24.2277 20.9699 23.9702C21.1695 23.7696 21.4177 23.4497 21.6766 23.1C22.7124 21.7311 23.9937 20.0315 25.8037 20.8826C25.8441 20.9016 25.8738 20.9233 25.9142 20.9396L31.9511 24.4283C31.9699 24.4391 31.9915 24.4581 32.0077 24.469C32.8034 25.0192 33.1325 25.8677 33.1406 26.83C33.1406 27.8086 32.7819 28.9092 32.2559 29.8389C31.5599 31.0669 30.5349 31.8801 29.3535 32.4169C28.2286 32.9373 26.977 33.2165 25.774 33.3954C23.8858 33.6747 22.1163 33.4957 20.3063 32.9373C18.5368 32.387 16.7538 31.479 14.8063 30.27L14.6633 30.1778C13.7705 29.6167 12.8048 29.0176 11.858 28.3101C8.39453 25.6807 4.86361 21.8829 2.56271 17.7029C0.634062 14.1952 -0.417931 10.4083 0.156619 6.80033C0.474914 4.82148 1.31921 3.02155 2.79199 1.83424C4.07596 0.793314 5.80501 0.224057 8.04386 0.424652C8.30012 0.443627 8.5294 0.592718 8.65078 0.814999L12.5216 7.39127C13.088 8.12859 13.1582 8.86049 12.848 9.59239C12.5917 10.1915 12.0738 10.7445 11.3671 11.2595C11.1594 11.4384 10.9112 11.62 10.6496 11.8098C9.7837 12.4414 8.79914 13.1706 9.13632 14.0272L9.12823 14.0055Z'
												fill='#8DC63F'
											/>
										</svg>

										<p className='text-black hover:text-lime-500 transition-all duration-150'>
											+1 (206) 452-5000
										</p>
									</div>
								</a>
							</div>
							<div>
								<a></a>
								<a href='mailto:joe@salesmrkt.com'>
									<div className='flex items-center justify-center gap-3'>
										<svg
											width='39'
											height='30'
											viewBox='0 0 39 30'
											fill='none'
											xmlns='http://www.w3.org/2000/svg'>
											<path
												d='M3.12222 1.28125H35.8781C36.4619 1.28125 36.9925 1.52033 37.3767 1.90425C37.7612 2.28876 38 2.82022 38 3.40347V25.9141C38 26.354 37.8642 26.7638 37.6323 27.1038C37.5899 27.2137 37.5236 27.3161 37.433 27.4031C37.3725 27.46 37.3059 27.5067 37.2355 27.5419C36.8666 27.8493 36.3927 28.0366 35.8781 28.0366H3.12222C2.53897 28.0366 2.00781 27.7978 1.62299 27.4133C1.23908 27.0291 1 26.4985 1 25.9141V3.40347C1 2.81901 1.23848 2.28816 1.62269 1.90425C2.00691 1.51973 2.53776 1.28125 3.12222 1.28125ZM2.6278 25.0213L14.1073 13.5129L2.6278 4.15323V25.0213ZM15.3716 14.5436L3.53654 26.4085H35.3641L24.0538 14.5454L20.3252 17.7224C20.0328 17.9723 19.595 17.9865 19.2855 17.7354L15.3716 14.5436ZM25.2917 13.4909L36.3722 25.1131V4.05085L25.2917 13.4909ZM3.66994 2.90905L19.7856 16.0492L35.2093 2.90905H3.66994Z'
												fill='#8DC63F'
												stroke='#84CC16'
												stroke-width='2'
											/>
										</svg>

										<p className='text-black hover:text-lime-500 transition-all duration-150'>
											joe@salesmrkt.com
										</p>
									</div>
								</a>
							</div>
						</div>
					</div>
				</div>
			</div>

			<Footer
				LetsTalkOpener={LetsTalkOpener}
				setLetsTalkOpener={setLetsTalkOpener}
				LoginMenuOpener={LoginMenuOpener}
				setLoginMenuOpener={setLoginMenuOpener}
				Four={navFour}
				setFour={setNavFour}
				numberId={FooterSelected}
				setNumber={setFooterSelected}
				recources={resources}
				budnles={bundles}
				setBundles={setBundles}
				setOne={setNavOne}
				setTwo={setNavTwo}
				setThree={setNavThree}
				One={navOne}
				Two={navTwo}
				Three={navThree}
				setExploreButton={setExploreButton}
				setRecources={setresources}
			/>
		</div>
	);
};

export default InvestorPage;
